/// <reference types="web-bluetooth" />
import { ref, registerRuntimeCompiler, watch, onMounted } from "vue";
import { createToast } from 'mosha-vue-toastify';
import { $database } from "@/jsstore_con";
import { CellRecord, IScanResult, ScanResult, ScanResultH, ScanResultS_lte, ScanResultS_5GNSA, ScanResultS_5GSA, ScanResultS_noService, ScanGPS, ScanResultS_wcdma, OperatoriTel, ScanResultS, ScanResultWiFi, wifiResult, blueResult, ScanResultBluetooth, ActiveCell, ActiveScan } from "./CellRecord";
import { b85encode, downloadBlob, } from "@/ts/fileutils";
import { Log } from "./Log";
import { BleClient, BleDevice, } from '@capacitor-community/bluetooth-le';
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { Capacitor } from '@capacitor/core';
import { Geolocation } from '@capacitor/geolocation';
import { VERSION } from "@/model";
import i18next from 'i18next';
import { FolderContainer } from '@/model';
import { downloadFileC } from "@/ts/fileutils";

const COMMAND_SERVICE_ID = '3cfee5c8-d5cf-41d2-8b10-23c5503c4fe5';
const COMMAND_SEND_CHARA = '00000000-0000-1000-8000-00805f9b34fb';
const COMMAND_FEEDBACK_CHARA = '00000001-0000-1000-8000-00805f9b34fb';
const SCAN_RESULT_A_CHARA = '00000002-0000-1000-8000-00805f9b34fb'
const SCAN_RESULT_B_CHARA = '00000004-0000-1000-8000-00805f9b34fb'
const SCAN_FEEDBACK_CHARA = '00000003-0000-1000-8000-00805f9b34fb'

/*
      const fileManagerCommandFeedbackChara = await fileManagerService.getCharacteristic('00000000-0000-1000-8000-00805f9b34fb');
      const fileManagerReceiverChara = await fileManagerService.getCharacteristic('00000001-0000-1000-8000-00805f9b34fb');
      const fileManagerChecksumChara = await fileManagerService.getCharacteristic('00000002-0000-1000-8000-00805f9b34fb');

*/

const FILEMANAGER_SERVICE_CHARA = '05674b70-ebda-11ec-8ea0-0242ac120002';
const FILEMANAGER_COMMAND_FB_CHARA = '00000000-0000-1000-8000-00805f9b34fb';
const FILEMANAGER_RECEIVER_CHARA = '00000001-0000-1000-8000-00805f9b34fb';
const FILEMANAGER_CHECKSUM_CHARA = '00000002-0000-1000-8000-00805f9b34fb';

export enum TechRadius {
  '5G' = 1000,
  'LTE' = 5000,
  '4G' = 5000,
  'UMTS' = 10000,
  '2G' = 15000,
  'GSM' = 15000
}

class FileBuffer {
  totalParts: number;
  buffer: Array<Uint8Array>;
  fileName: string;
  currentChecksum = ""
  receivedParts = 0;

  constructor(fileName: string, totalParts: number) {
    this.fileName = fileName;
    this.totalParts = totalParts;
    this.buffer = new Array<Uint8Array>(totalParts);
  }

  public addPart(part: DataView) {
    if (this.receivedParts > this.totalParts) {
      throw "FileBuffer.addPart: all parts received";
    }
    this.buffer[this.receivedParts] = new Uint8Array(part.buffer) // don't merge or it would be too cpu & ram intensive
    this.receivedParts++;
  }

  public isComplete(): boolean {
    return this.receivedParts >= this.totalParts;
  }

  public getFileName(): string {
    return this.fileName;
  }

  public getBuffer(): Uint8Array[] {
    return this.buffer;
  }

  public async saveToFile(fileName: string) {
    if (!this.isComplete()) throw "FileBuffer.saveToFile: not complete";
    Log.info("FileBuffer.saveToFile: saving file " + fileName);

    const blob = new Blob(this.buffer, { type: "text/plain;charset=utf-8", });

    if (Capacitor.isNativePlatform()) {
      //console.warn("sharing method")


      let stringToWrite = "";

      await Filesystem.writeFile({
        path: "BTSTracker/" + fileName,
        data: "**cjson**\n[",
        recursive: true,
        directory: Directory.Documents,
        encoding: Encoding.ASCII
      });

      for (let i = 0; i < this.buffer.length; i++) {
        for (let j = 0; j < this.buffer[i].length; j++) {
          stringToWrite += this.buffer[i][j];
          // if is not the last element add ,
          if (j != this.buffer[i].length - 1) {
            stringToWrite += ",";
          }
        }

        if (i != this.buffer.length - 1) {
          stringToWrite += ",";
          await Filesystem.appendFile({
            data: stringToWrite,
            path: "BTSTracker/" + fileName,
            directory: Directory.Documents,
            encoding: Encoding.ASCII
          });
          stringToWrite = "";
        }
      }

      await Filesystem.appendFile({
        data: stringToWrite + "]\n",
        path: "BTSTracker/" + fileName,
        directory: Directory.Documents,
        encoding: Encoding.ASCII
      });

    } else {
      downloadBlob(blob, fileName);
    }
  }
}

class FoldersBuffer {
  totalParts: number;
  receivedParts = 0;
  buffer = "";
  constructor(totalParts: number) {
    this.totalParts = totalParts;
  }
  public addPart(part: string) {
    this.buffer += part;
    this.receivedParts++;
    if (this.receivedParts > this.totalParts) {
      throw "FileBuffer.addPart: all parts received";
    }
    //console.log(part);
  }
  public getBuffer(): string {
    return this.buffer;
  }
  public isComplete(): boolean {
    return this.receivedParts >= this.totalParts;
  }
}

export class accordionListItem {
  id: number;
  name: string;
  hide = false;

  constructor(id?: any) {
    this.id = id;
    this.name = "#Item " + this.id;
  }
}

class Command {
  command: Record<string, unknown>;
  commandResolverOk: (a: Record<string, unknown>) => void;
  constructor(command: Record<string, unknown>, commandResolverOk: (a: Record<string, unknown>) => void) {
    this.command = command;
    this.commandResolverOk = commandResolverOk;
  }
}

class ScanMap {
  power = 0;
  tec = "";
  coords: number[] = [];
  constructor(power: number, tec: string, long: number, lat: number) {
    this.power = power;
    this.tec = tec;
    this.coords[0] = long;
    this.coords[1] = lat;
  }
}

interface cellInfo {
  band: string;
  power: number;
}

export class wirelessNetwork {
  macAddress: string;
  name: string;
  hide = false; // per averla nella lista, ma non utilizzarla nella ricerca/visualizzazione 
  parentsInfo = new accordionListItem();
  find = false;
  count = 0;

  constructor(macAddress?: string, name?: string) {
    this.macAddress = macAddress != null ? macAddress : "";
    this.name = name != null ? name : "";
  }
}

export class cell {
  mcc = "";
  mnc = "";
  lac = "";
  cellid = "";
  location = { "lat": 0, "long": 0 };
  az = 0;
  bh = 360;
  tec = "";

  constructor(mcc: string, mnc: string, lac: string, cellid: string) {
    this.mcc = mcc;
    this.mnc = mnc;
    this.lac = lac;
    this.cellid = cellid;
  }

  reset(): void {
    this.mcc = "";
    this.mnc = "";
    this.lac = "";
    this.cellid = "";
  }

  makeCode(type: boolean): string {
    let cellcode = "";
    if (type == false) {
      if (this.mcc.length == 0) cellcode = "(*)-";
      else cellcode = this.mcc + "-";
      if (this.mnc.length == 0) cellcode += "(*)-";
      else cellcode += this.mnc + "-";
      if (this.lac.length == 0) cellcode += "(*)-";
      else cellcode += "(*)" + this.lac + "(*)-";
      if (this.cellid.length == 0) cellcode += "(*)";
      else cellcode += "(*)" + this.cellid + "(*)";
    } else {
      cellcode = this.mcc + "-" + this.mnc + "-" + this.lac + "-" + this.cellid;
    }
    return cellcode;
  }
}

export class searchCell {
  name = ""; // codice
  number = 0; // conteggio
  source = ""; // da inserimento manuale o qrcode
  view = false; // visualizzare in mappa solo se scansionato da qrcode
  hide = false; // per averla nella lista, ma non utilizzarla nella ricerca/visualizzazione 
  cellcode = new cell("", "", "", "");
  valueQrCode = "";
  oldName = "";
  color = "#FF0000";
  group = 0;
  parentsInfo = new accordionListItem();
  find = false;
  count = 0;

  constructor(name: string, cellcode: cell) {
    this.name = name;
    this.cellcode = cellcode;
  }

  reset(): void {
    this.name = "";
    this.number = 0;
    this.source = "";
    this.view = false;
    this.hide = false;
    this.cellcode = new cell("", "", "", "");
    this.valueQrCode = "";
  }

  controlloCode(code: string): void {
    this.oldName = code;
    this.splitCode();
    if (this.cellcode.cellid.length > 5) {
      const lac = Math.round(parseInt(this.cellcode.cellid) / 256);
      const cellid = Math.round(parseInt(this.cellcode.cellid) % 256);
      this.cellcode.lac = lac.toString();
      this.cellcode.cellid = cellid.toString();
    }
    if (this.cellcode.cellid.length == 5 || this.cellcode.cellid.length == 3) {
      // codice cella corretto
    }
    if (this.cellcode.cellid.length > 3 && this.cellcode.cellid.length < 5) {
      while (this.cellcode.cellid.length < 5) {
        this.cellcode.cellid = "0" + this.cellcode.cellid;
      }
      while (this.cellcode.lac.length < 5) {
        this.cellcode.lac = "0" + this.cellcode.lac;
      }
    } else if (this.cellcode.cellid.length < 3) {
      while (this.cellcode.cellid.length < 3) {
        this.cellcode.cellid = "0" + this.cellcode.cellid;
      }
      while (this.cellcode.lac.length < 7) {
        this.cellcode.lac = "0" + this.cellcode.lac;
      }
    }

    this.name = this.cellcode.makeCode(true);
  }

  splitCode(): void {
    if (this.name.length > 0) {
      const cellPart = this.name.split("-");
      this.cellcode.mcc = cellPart[0];
      this.cellcode.mnc = cellPart[1];
      this.cellcode.lac = cellPart[2];
      this.cellcode.cellid = cellPart[3];
    }
  }
}

export class BTSTracker {

  // bts
  lastVersionF = "1.2.0.25260";
  connected = false;
  connecting = false;
  // battery 
  batteryPercentage = 0;
  mediaBatteria = 0;
  millivolts = 0;
  currVoltage = 0;
  usbConnected = 0;
  acok = 0;

  private static stringEncoder = new TextEncoder();
  private static stringDecoder = new TextDecoder("utf-8");

  isScanning = false;
  startScan = false;
  startCallTest = false;
  scanOnlyCall = false;
  selectedSIM: string[] = [];
  startScanSearch = true;
  tech = ['LTE', 'UMTS', 'GSM', ' '];
  technologies = [' '];
  modeS = '2';
  autoConnection = '5G';
  fallback = true;
  colonneDis = ['cell', 'freq', 'down_up', 'power', 'oper'];
  colonneActive = ['code', 'tec', 'arfcn', 'band', 'segnale', 'type', 'operator'];
  colonneWifi = ['mac', 'network', 'signal', 'encryp', 'freq', 'vendor'];
  colonneBlue = ['mac_', 'name', 'signal_', 'adv_type', 'remote', 'vendor'];

  lista = "1"; // visualizzazione files "0"-> icone; "1"-> lista
  fileBuffer: FileBuffer | undefined;
  folderBuffer: FoldersBuffer | undefined;
  selectedFiles: string[] = [];
  dialogDelete = false;
  dialogConvert = false;
  dialogDownload = false;
  // time and date da get_info
  deviceTime = "";
  deviceData = "";
  deviceDataTime = "";
  caricamentoSD = true;

  fileName = ""; // scan file
  NameFile = "";
  lastFileName = "";
  folder = "scan";
  timeStartScan = ""; // start time of scan
  gpsBTS4G = 0; // module 4G: not found = 0, connected = 1
  gpsBTS5G = 0; // module 5G: not found = 0, connected = 1
  restart = false;

  // list for map view 
  listCoordScansioni: ScanMap[] = [];
  listCoordPosizioni: number[][] = [];

  // cell results for AutoConnection
  cellLTE: ScanResultS_lte | undefined;
  cell5GNSA: ScanResultS_5GNSA | undefined;
  cell5GSA: ScanResultS_5GSA | undefined;
  cellNoSer: ScanResultS_noService | undefined;
  cellLTE2: ScanResultS_lte | undefined;
  cell5GNSA2: ScanResultS_5GNSA | undefined;
  cell5GSA2: ScanResultS_5GSA | undefined;
  cellNoSer2: ScanResultS_noService | undefined;
  cellwcdma: ScanResultS_wcdma | undefined;
  cellwcdma2: ScanResultS_wcdma | undefined;
  // cell results for LTE - UMTS - GSM
  cellHlte: ScanResultH | undefined;
  cellHumts: ScanResultH | undefined;
  cellHgsm: ScanResultH | undefined;
  // wifi
  wifiScan: ScanResultWiFi | undefined;
  //bluetooth
  blueScan: ScanResultBluetooth | undefined;
  // cell 2G active set
  cellActive: ActiveCell | undefined;
  cellScanActive: ActiveScan | undefined;
  activeNONE = false;
  mcc_mncServingCell = "";

  responseCallTest1: string[] = []; //response of Test call sim 1
  responseCallTest2: string[] = []; //response of Test call sim 2
  waitingForCallTest1 = false;
  waitingForCallTest2 = false;

  errorWifi = false;
  errorBlue = false;

  closeConnected = false;
  closeAvailable = false;
  closeLTE = false;
  closeUMTS = false;
  closeGSM = false;
  closeWifi = false;
  closeBlue = false;
  close2g = false;

  appLocation: {
    latitude: number;
    longitude: number;
    accuracy: number;
    altitudeAccuracy: number | null | undefined;
    altitude: number | null;
    speed: number | null;
    heading: number | null;
  } | undefined = undefined;

  manuallyPosition = false;
  newPoint = false;
  deleteManuallyPosition = false; // quando viene eliminata la posizione manuale
  manuallyCoordinates: {
    latitude: number;
    longitude: number;
  } = { latitude: 0, longitude: 0 }; // latitude, longitude posizione settata manualmente
  dialogSetLocation = false;
  seeManualLocation = false;

  // file characteristics
  connectedDeviceId: BleDevice | undefined = undefined;

  notificationAudio: HTMLAudioElement | null = null

  fileBufferPromiseResolver: undefined | ((a: FileBuffer) => void);
  folderBufferPromiseResolver: undefined | ((a: FoldersBuffer) => void);

  // count of scan results
  scanResults = 0;
  scanResultsS = 0;
  scanResultsH = 0;
  netResultL = 0;
  netResultG = 0;
  netResultU = 0;
  timeLte = "";
  timeUmts = "";
  timeGsm = "";
  timeWifi = "";
  timeBluetooth = "";
  timeActive = "";
  scanResultWifi = 0;
  scanResultBlue = 0;
  scanResultActive = 0;

  moreWifi = false;
  moreBlue = false;

  commands: Command[] = [];
  currentCommandObject: Command | undefined = undefined;
  availableAt = new Date().getTime();

  // gps
  tipo = 0; // type of gps --> se client = -1, se BTS = 1
  latitude = 0.0;
  longitude = 0.0;
  altitude = 0.0;
  accuracy = 0.0;
  speed = 0;
  geoLocationError = false;
  course = 0.0;
  link = "https://google.com/maps/@" + this.latitude + "," + this.longitude;
  antennaGPS = false;
  // sd card
  valid = 0;
  sdCardError = false;
  sdCardTotalSize = 0;
  sdCardUsedSize = 0;
  updateSD = false;
  // sim 
  numSim = 0;
  simH = "";
  simS1 = "";
  imsi1_old = "";
  simS2 = "";
  imsi2_old = "";
  opeSim1: OperatoriTel | undefined;
  opeSim2: OperatoriTel | undefined;
  opeSim0: OperatoriTel | undefined;
  checkimsi = true;
  pin1 = "";
  pin2 = "";
  // bts info
  serial = "";
  version = "";
  licenseActive = -1;
  infoLicense: string[] = [];
  init = 0;
  bootSeconds = 0;
  perc = 0;
  resultInit = "";
  modA = 0;
  modB = 0;

  datetime = "";

  errorOta = "";
  updateStart = false;
  // state of cell results
  stateLTE = 0;
  stateNO = 0;
  state5GNSA = 0;
  state5GSA = 0;
  stateLTE2 = 0;
  stateNO2 = 0;
  state5GNSA2 = 0;
  state5GSA2 = 0;
  stateWcdma = 0;
  stateWcdma2 = 0;
  stateActive = 0;
  // slot of sim
  slot1 = false;
  slot2 = false;

  staticName = false;
  searchName = "";

  sendLocationToBtsTrackerTimeoutID: number | undefined;

  aops: string[] = [];
  cellList = "";
  interestedCell: searchCell[] = [];
  accordionList: accordionListItem[] = [];
  interestedWifi: wirelessNetwork[] = [];
  interestedBluetooth: wirelessNetwork[] = [];
  qrcodeinfo = "";
  totalInterestedCell = 0;
  noInterestedCell = false;
  stopSave = false;
  countCellB1 = 0;
  countCellB2 = 0;
  connectedCell = true;
  availableCell = true;
  wifi = true;
  blue = true; // scansioni bluetooth attive
  reloadFolder = false;
  checkAccuracy = false;

  lastPosition: GeolocationCoordinates | undefined;

  apnSettings = false;
  ftpSettings = false;
  apnLauched = false;
  ftpLauched = false;
  APNlist = "";
  apn1 = "";
  userApn1 = "";
  passApn1 = "";
  apn2 = "";
  userApn2 = "";
  passApn2 = "";
  ftp = "";
  userFtp = "";
  passFtp = "";
  staticInfo = false;
  enableapn = false;
  sceltaSim = '1';
  reportUpload = false;
  differentSim1 = false;
  differentSim2 = false;

  searchAPN = "";
  selectAPN1 = 0;
  selectAPN2 = 0;

  restart_hua = false;
  modem = 1;
  checkGeolocation = true;

  moduleA = "";
  moduleB = "";
  moduleWifi = -1;

  wifiLimit = 0;
  blueLimit = 0;

  activeSet = false;
  check = false;
  readyForScanning = false;
  device: BleDevice | undefined;

  sito = "";
  percLoadingLicense = "";

  file: FolderContainer | undefined = undefined;
  convert = false;
  downloading = false;
  convertMultipleFiles = false;
  countFiles = 0;
  downloadMultipleFiles = false;

  constructor() {
    this.sito = document.location.href;
    const anyNav: any = navigator
    if ('wakeLock' in navigator) {
      try {
        anyNav["wakeLock"].request("screen");
      } catch (error) {
        console.error(error);
      }
    }

    setInterval(async () => {

      if (this.connected && this.connectedDeviceId && !this.currentCommandObject) {
        if (this.commands.length > 0) {
          this.currentCommandObject = this.commands.shift();
          try {
            const uintarr = BTSTracker.stringEncoder.encode(JSON.stringify(this.currentCommandObject?.command) + '\0');
            await BleClient.write(this.connectedDeviceId.deviceId, COMMAND_SERVICE_ID, COMMAND_SEND_CHARA, new DataView(uintarr.buffer, 0, uintarr.byteLength));
          } catch (error) {
            Log.error(error);
            Log.error(BTSTracker.stringEncoder.encode(JSON.stringify(this.currentCommandObject?.command) + '\0'));
          }
        } else {
          if (new Date().getTime() - this.availableAt >= 20000) {
            this.availableAt = new Date().getTime();
            setTimeout(() => {
              try {
                if (this.licenseActive) {
                  this.updateInfos().catch(err => {
                    Log.error(err);
                  }).then(() => this.availableAt = new Date().getTime());
                }
              } catch (error) {
                Log.error(error);
              }
            }, 500)
          }
        }
      }
    }, 150);
    this.deviceTime = "";
  }

  public saveScreen(): void {
    //console.log("save.2")
    const canvas = document.getElementsByTagName("canvas")[0];
    const img = canvas.toDataURL();
    //console.log("check file system", Capacitor.isPluginAvailable('Filesystem'));
    if (Capacitor.isNativePlatform()) {
      console.warn("capacitor");
      Filesystem.writeFile({
        path: `BTSTracker/${Date.now()}-screen.png`,
        data: img,
        recursive: true,
        directory: Directory.Documents,
      }).then((x) => {
        console.log(x)
        createToast(
          {
            title: i18next.t("createToast.screenSaved"),
          },
          {
            type: 'success',
            showIcon: true,
            hideProgressBar: true,
          });
      });

    } else {
      _downloadFile(img, Date.now() + ".png", "");
      createToast(
        {
          title: i18next.t("createToast.screenSaved")
        },
        {
          type: 'success',
          showIcon: true,
          hideProgressBar: true,
        });
    }


    console.log(img);
  }


  async sendManualLocationToBtsTracker(manualLocation: { latitude: number, longitude: number }) {
    //console.log("update manual gps");
    await this.sendCommand("update_manual_gps", {
      "latitude": manualLocation.latitude,
      "longitude": manualLocation.longitude,
      "use": this.manuallyPosition,
    });
  }

  sendLocationToBtsTracker(geoLoc: {
    latitude: number;
    longitude: number;
    accuracy: number;
    altitudeAccuracy: number | null | undefined;
    altitude: number | null;
    speed: number | null;
    heading: number | null;
  }): void {
    // quando si apre il browser partono un sacco di richieste, per evitare un sacco di chiamate
    // metto un timer con un leggero ritardo. In questo modo le chiamate troppo ravvicinate vengono 
    this._sendLocationToBtsTracker(geoLoc);
  }

  _sendLocationToBtsTracker(geoLoc: {
    latitude: number;
    longitude: number;
    accuracy: number;
    altitudeAccuracy: number | null | undefined;
    altitude: number | null;
    speed: number | null;
    heading: number | null;
  }): void {

    /*if (typeof this.sendLocationToBtsTrackerTimeoutID === 'number') {
      clearTimeout(this.sendLocationToBtsTrackerTimeoutID);
    }*/


    this.sendLocationToBtsTrackerTimeoutID = setTimeout(() => {
      //console.log("update_gps");

      this.sendCommand("update_gps", {
        "latitude": geoLoc.latitude.toFixed(5),
        "longitude": geoLoc.longitude.toFixed(5),
        "accuracy": geoLoc.accuracy.toFixed(3),
        "speed": geoLoc.speed ? geoLoc.speed.toFixed(3) : null,
        "altitude": geoLoc.altitude ? geoLoc.altitude.toFixed(3) : null,
        "altitudeAccuracy": geoLoc.altitudeAccuracy ? geoLoc.altitudeAccuracy.toFixed(3) : null,
        "heading": geoLoc.heading ? geoLoc.heading.toFixed(3) : null
      });

      this.sendLocationToBtsTrackerTimeoutID = undefined;

    }, 5000);

  }

  public licenceDownload() {
    this.licenseActive = -1;
    // controllo lic32
    console.warn("controlli lic32");
    createToast({
      title: i18next.t("createToast.startLoadingLic"),
    }, {
      type: 'success',
      showIcon: true,
      hideProgressBar: true,
    });
    // Define the body data
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      "machine_code": this.serial,
      "project_public_key": "LS0tLS1CRUdJTiBQVUJMSUMgS0VZLS0tLS0NCk1JSUNJakFOQmdrcWhraUc5dzBCQVFFRkFBT0NBZzhBTUlJQ0NnS0NBZ0VBanZ2MTR3Wkg5WWovc0xodW0yQWoNCmFza2ZKRjFrSHhERW1pWGtKWmxlL0FJOUdjcFBzMURNTDdtaFh1WjhRRjYxN1U0a3FHdlJLVkZwT09kUEtWUDANCm1hNEQveTNqK0FLSWVLZjh4U3Z5MHpDczBOWnRkTjFlc3FnTmdyWGpTNFAyQVBrU2hiNFBvalQxM3BtSmxiSHcNCmFwM2N2K3Z1SHY1cUlBWmJVdWdBY3pLY01Jc1VSd1U4UG1wUE9RQ3lXczJDRkdsUE5PQnJBcTQ1K0JObDZCbXMNCjYyak1zazVSeWFodUhpUE03d0tseHpjdUlTSWpBbEROZ1dDY2VnRkxhbFZwTTk2a2UvalEyTnJBNVFBdEhmZ0oNCmpMWXJZbnlxcDIrTit2T1RWS01TMzFpZUk3U0tFUDQrd0YrN2VxU2dJUXdqcUhYR0x3eWhiMGV2eTlhM2lLdFQNCjlOd3pkdDFPSE80aGpFOUNCVG92NXp5M2lVMGg5akdLYnNndnpMbjJKZjYyT1ZBNDhSRTlBTFA4VVYzdEgyamQNCk9ZeGFlRzZLMHhUc2t6TEZWVVFCL3FaNGpRdGg1NHhkdnpnUjhaOEgwUlBEOGhmUUhlc0xEOElkTCtsVE1LaTMNCmdjcjlUTEtBeFJGME1LeGpVUk13Q2U1WEM0N1RPMHA3TWY2bjdMYnp4UTZwL2MraTdteTJDUm5qMXdRd0pOS2kNCmg5N2RncjFtSjh0RXVFK3hmRFJ4aEdKVmpoMG9waEFNT012Z240OTV4QlkyeGliM1hNSW9iSUlSZHFFVklsaFgNCjJiZVBqWHdEcHZyZGRLRzEvKzcwaGNqSWY5OGlkMjMwTVpTd3JObnhkckhmU2Y2QTg1UzhQNXlHTXZpU3JzY0INCnJ5Y1ZTR3RpMGtjQ0lUb0tSL1AvUlQ4Q0F3RUFBUT09DQotLS0tLUVORCBQVUJMSUMgS0VZLS0tLS0NCg=="
    });

    const response = fetch("https://lic32.securcube.net/api/v1/license/check/2", {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    }).then((response) => response.text())
      .then((result) => {
        // ricezione contenuto data
        const content = JSON.parse(result);
        const encoder = new TextEncoder();
        const uint8Array = encoder.encode(content.data);
        const arrayBuffer: ArrayBuffer = uint8Array.buffer.slice(0) as ArrayBuffer;
        this.sendLicense(arrayBuffer);
      })
      .then((result) => {
        if (this.licenseActive <= 0) {
          this.licenseActive = 0;
          createToast({
            title: i18next.t("license.noLicense"),
          }, {
            type: 'danger',
            showIcon: true,
            hideProgressBar: true,
          });
        } else {
          this.updateInfos();
          this.apn_ftp();
          this.update();
        }
      })
      .catch((error) => {
        // se non c'è connessione
        console.error(error)
        createToast({
          title: i18next.t("license.noLicense"),
        }, {
          type: 'danger',
          showIcon: true,
          hideProgressBar: true,
        });
      });
  }

  public async createConnection() {
    if (this.connected || this.connectedDeviceId || this.connecting) return;
    try {
      this.connecting = true;

      this.commands = [];
      this.deviceTime = "";
      this.isScanning = false;
      this.fileBufferPromiseResolver = undefined;
      this.fileBuffer = undefined;
      this.scanResultsS = 0;
      this.scanResultsH = 0;
      this.folderBuffer = undefined;
      this.folderBufferPromiseResolver = undefined;
      this.currentCommandObject = undefined;


      //console.log("Requesting Bluetooth Device...");

      await BleClient.initialize();

      const device = await BleClient.requestDevice({
        services: [COMMAND_SERVICE_ID, FILEMANAGER_SERVICE_CHARA],
        optionalServices: [COMMAND_SERVICE_ID, FILEMANAGER_SERVICE_CHARA]
      });

      if (!device) throw "No device selected";


      await BleClient.connect(device.deviceId, () => this.onDisconnect());

      await BleClient.startNotifications(device.deviceId, COMMAND_SERVICE_ID, COMMAND_FEEDBACK_CHARA, (result) => {
        $BTSTracker.value.handleCommandFeedback(result);
      });
      await BleClient.startNotifications(device.deviceId, COMMAND_SERVICE_ID, SCAN_RESULT_A_CHARA, (result) => {
        $BTSTracker.value.handleScanResultA(result);
      });
      await BleClient.startNotifications(device.deviceId, COMMAND_SERVICE_ID, SCAN_RESULT_B_CHARA, (result) => {
        $BTSTracker.value.handleScanResultB(result);
      });

      await BleClient.startNotifications(device.deviceId, FILEMANAGER_SERVICE_CHARA, FILEMANAGER_RECEIVER_CHARA, (result) => {
        $BTSTracker.value.handleFileManagerReceiver(result);
      });

      await BleClient.startNotifications(device.deviceId, FILEMANAGER_SERVICE_CHARA, FILEMANAGER_CHECKSUM_CHARA, (result) => {
        $BTSTracker.value.handleChecksumFeedback(result);
      });

      this.connectedDeviceId = device;
      this.connecting = false;
      this.connected = true;

      await this.sendCommand("set_time", { "time": Math.trunc(Date.now()) });

      const resp: Record<string, any> = await this.sendCommand("get_bts_info", {});
      this.gpsBTS4G = 0; // module 4G: not found = 0, connected = 1
      this.gpsBTS5G = 0; // module 5G: not found = 0, connected = 1

      if (resp.ok) {
        const tmp = (resp.msg as string).split(";");
        this.serial = tmp[0];
        this.version = tmp[1];
      }

      this.checkAllLicense();

    } catch (e) {
      Log.error(e);
      await this.onDisconnect(false);
    }
  }

  /*
    start LICENZA
  */
  // controllo licenza
  public async checkAllLicense() {
    // controllo licenza inizio
    const licResp: Promise<boolean> = this.checkLicense();
    if (await licResp) {
      this.licenseActive = 1;
      createToast({
        title: i18next.t("createToast.activeLic"),
      }, {
        type: 'success',
        showIcon: true,
        hideProgressBar: true,
      });

    } else { // se non c'è licenza 
      // se non è presente la licenza da file, richiesta a lic32
      this.licenceDownload(); console.log("licence download");
    }

    if (location.host.indexOf("detect26l") >= 0 || location.host.indexOf("localhost") >= 0) {
      this.licenseActive = 1;
      console.log(location.host)
    }

    if (this.licenseActive == 1) {
      this.updateInfos();
      this.apn_ftp();
      this.update();
    }
    console.log(this.licenseActive);
  }

  // invio file licenza 
  public async sendLicense(file: ArrayBuffer) {
    console.log("send license");
    // eliminazione licenza già presente
    this.sendCommand("deleteLicense", { "delete": true }).then((res) => {
      if (res.ok) {
        createToast({
          title: i18next.t("createToast.startLoadingLic")
        }, {
          type: 'success',
          showIcon: true,
          hideProgressBar: true,
        });
        // invio file 
        const response: Promise<boolean> = this.sendFile(file);
      } else {
        createToast({
          title: i18next.t("createToast.errorLoading")
        }, {
          type: 'warning',
          showIcon: true,
          hideProgressBar: true,
        });

        if (location.host.indexOf("detect26l") >= 0 || location.host.indexOf("localhost") >= 0) {
          this.licenseActive = 1;
        } else {
          this.licenseActive = 0;
        }
      }
    });

  }

  // INVIO FILE LICENZA DA WEB APP A ARDUINO
  public async sendFile(fileBuffer: ArrayBuffer): Promise<boolean> {
    //console.log("SEND FILE");
    //console.log(fileBuffer)
    if ($BTSTracker.value.connectedDeviceId == undefined) return false;
    if (!fileBuffer || fileBuffer.byteLength <= 0) return false;

    // Split and send file chunks
    const chunkSize = 150;
    const totalChunks = Math.ceil(fileBuffer.byteLength / chunkSize);
    //console.log("Total chunks: " + totalChunks);
    this.percLoadingLicense = "";
    try {
      // Split the file buffer into chunks if it's too large
      for (let i = 0; i < fileBuffer.byteLength; i += chunkSize) {
        const chunk = fileBuffer.slice(i, i + chunkSize);
        await BleClient.write($BTSTracker.value.connectedDeviceId.deviceId, FILEMANAGER_SERVICE_CHARA, FILEMANAGER_RECEIVER_CHARA, new DataView(chunk));
        this.percLoadingLicense = ((i + 1) / fileBuffer.byteLength * 100).toFixed(2);
        //console.log(this.percLoadingLicense);
      }
      this.percLoadingLicense = "";
      //console.log("File sent successfully over Bluetooth.");

      const resp: Record<string, any> = await this.sendCommand("checkLicense", {});
      console.warn(resp);
      if (resp.ok) {
        // controllo licenza 
        const licResp: Promise<boolean> = this.checkLicense();
        if (await licResp) {
          this.licenseActive = 1;
          createToast({
            title: i18next.t("createToast.activeLic"),
          }, {
            type: 'success',
            showIcon: true,
            hideProgressBar: true,
          });
        } else {
          this.licenseActive = 0;
          createToast({
            title: i18next.t("license.noLicense"),
          }, {
            type: 'danger',
            showIcon: true,
            hideProgressBar: true,
          });
        }
      }

    } catch (error) {
      createToast({
        title: i18next.t("createToast.uploadErrLic"),
      }, {
        type: 'danger',
        showIcon: true,
        hideProgressBar: true,
      });
      this.licenseActive = 0;
    }
    return true;
  }

  // richiesta licenza al BTS 
  public async checkLicense(): Promise<boolean> {
    const licResp: Record<string, any> = await this.sendCommand("get_license", {});
    if (licResp.ok) {
      // lettura licenza da file SD card
      const tmp = (licResp.msg as string).split(";");
      const licenseActive = Number.parseInt(tmp[0]); // indice: 0 licenza assente/invalida, 1 licenza valida
      tmp[1] = tmp[1].replaceAll("*", "\n");
      this.infoLicense = tmp[1].split("|"); // informazioni licenza
      if (licenseActive == 0) {
        return false;
      } else {
        return true;
      }
    } else {
      if (licResp.msg == "unknown_command") {
        createToast({
          title: i18next.t("createToast.updateFirmware"),
        }, {
          type: 'danger',
          showIcon: true,
          hideProgressBar: true,
        });
      }
      return false;
    }
  }
  /*
    end LICENZA
  */

  private async update() {
    if (this.version.indexOf(this.lastVersionF) < 0) {
      createToast(
        {
          title: i18next.t("createToast.availableUpdate"),
          description: i18next.t("createToast.availableUpdateDes"),
        }, {
        type: 'warning',
        showIcon: true,
        hideProgressBar: true,
      }
      );
    }

  }

  private async onDisconnect(showError = true) {
    //console.log("DISCONNECTED");
    $BTSTracker.value.connected = false;
    $BTSTracker.value.connecting = false;

    if (showError) {
      createToast(
        {
          title: i18next.t("createToast.connectionStop"),
          description: i18next.t("createToast.connectionStopDesc"),
        },
        {
          type: 'danger',
          showIcon: true,
          hideProgressBar: true,
        });
    }
    if ($BTSTracker.value.connectedDeviceId) {
      try {
        await BleClient.disconnect($BTSTracker.value.connectedDeviceId.deviceId);
      } catch (error) {
        Log.error(error);
      }
    }

    $BTSTracker.value.connectedDeviceId = undefined;
  }

  async coordinates() {

    const coordinates = await Geolocation.getCurrentPosition();
    //console.log(coordinates);
    //console.log(this.manuallyPosition);

    if (this.gpsBTS4G == 0 && this.gpsBTS5G == 0) {
      if (this.manuallyPosition == false || this.deleteManuallyPosition == true) { // se la posisione è in base al browser
        this.tipo = -1;
        this.latitude = (Number)(coordinates.coords.latitude.toFixed(5));
        this.longitude = (Number)(coordinates.coords.longitude.toFixed(5));
        this.accuracy = (Number)(coordinates.coords.accuracy.toFixed(3));
        if (coordinates.coords.speed != undefined) {
          this.speed = coordinates.coords.speed;
        }
        $BTSTracker.value.appLocation = coordinates.coords;
        this.manuallyCoordinates.latitude = (Number)(this.latitude.toFixed(5));
        this.manuallyCoordinates.longitude = (Number)(this.longitude.toFixed(5));
      }
    } else {
      this.manuallyPosition = false;
    }
    if (this.manuallyPosition && this.gpsBTS4G == 0 && this.gpsBTS5G == 0) { // se la posizione è manuale
      //console.log("MANUAL");
      this.latitude = (Number)(this.manuallyCoordinates.latitude.toFixed(6));
      this.longitude = (Number)(this.manuallyCoordinates.longitude.toFixed(6));
    }

    if (!$BTSTracker.value.isConnected()) {
      this.geoLocationError = false; // altrimenti il dialog di avviso rimane aperto.
      return;
    }
    if (this.isConnected()) {
      this.sendLocationToBtsTracker(coordinates.coords);
      this.sendManualLocationToBtsTracker(this.manuallyCoordinates);
    }

    if (this.newPoint) {
      this.newPoint = false;
    }

    this.deleteManuallyPosition = false;
  }

  /*
  PER POSIZIONI GPS
  MODULO 4G
  SCANSIONI WIFI E BLUETOOTH
  */
  async handleScanResultA(result: DataView) {
    if (this.readyForScanning) {
      this.perc = 100;
      this.init = 1;
    }
    // LISTA DELLE POSIZIONI PER LA MAPPA QUANDO LA SCANSIONE è IN CORSO
    if (this.isScanning == true) {
      const location = [(Number)($BTSTracker.value.longitude.toFixed(5)), (Number)($BTSTracker.value.latitude.toFixed(5))];
      const l = this.listCoordPosizioni.length;
      if (l == 0) {
        this.listCoordPosizioni.push(location);
      } else if (this.listCoordPosizioni.length >= 1) {
        if ((Number)($BTSTracker.value.longitude.toFixed(5)) != this.listCoordPosizioni[l - 1][0]) {
          this.listCoordPosizioni.push(location);
        } else if ((Number)($BTSTracker.value.latitude.toFixed(5)) != this.listCoordPosizioni[l - 1][1]) {
          this.listCoordPosizioni.push(location);
        }
      } else {
        this.listCoordPosizioni.push(location);
      }
      if (l == 2 && this.listCoordPosizioni[1][0] - this.listCoordPosizioni[0][0] == this.listCoordPosizioni[1][0]) {
        this.listCoordPosizioni.shift();
      }
    }

    try {

      if ($BTSTracker.value.connectedDeviceId) {
        const str = BTSTracker.stringDecoder.decode(result);
        try {

          if (str.startsWith("{")) {
            const jsonData = JSON.parse(str);

            console.warn(jsonData);

            const modem = (Number)(jsonData.ind);
            const scannum = (Number)(jsonData.num ?? jsonData.surveyNum); // rinominato dalla versione 
            let atCommand = (String)(jsonData.d ?? jsonData.data);
            const parte = (String)(jsonData.tp);
            atCommand = atCommand.replaceAll("wifi;start;;", "");
            atCommand = atCommand.replaceAll("bt;start;;", "");
            atCommand = atCommand.replace("[BLE Device] GAP scan start;;", "");
            // scansioni reti wifi e bluetooth
            if (modem == 2) {
              console.log(modem);
              atCommand = atCommand.replaceAll("\r;", ";");
              atCommand = atCommand.replaceAll("\r", "");
              /* 
              SCANSIONI WIFI 
              */
              if (parte.startsWith("W")) {
                const num_parte = (Number)(parte.replace("W", ""));
                const result = wifiResult.parseWifi(atCommand, scannum);
                if (atCommand.indexOf("wifi") >= 0) {
                  if (result == undefined) {
                    this.errorWifi = true;
                    this.scanResultWifi = scannum;
                  } else if (result) {
                    this.errorWifi = false;
                    if (num_parte == 0) {
                      this.moreWifi = false;
                      this.wifiScan = result;
                      this.wifiScan.time = new Date();
                      this.listCoordScansioni.push(new ScanMap((Number)(this.wifiScan.network[0].signal), "wifi", this.longitude, this.latitude));
                      const event = new Event('on-scan-result-coming');
                      document.dispatchEvent(event);
                    } else {
                      for (let i = 0; i < result.network.length; i++) {
                        this.wifiScan?.addScan(result.network[i].name, result.network[i].signal, result.network[i].encryp, result.network[i].mac, result.network[i].frequency, result.ScanNumber, false);
                      }
                    }
                    this.scanResultWifi = scannum;
                    this.wifiScan?.network.sort((x, y) => y.signal - x.signal);

                  }
                }

              }
              if (this.wifiScan != undefined && (atCommand.indexOf("end") > 0 || atCommand.indexOf("more") > 0)) {
                for (let i = 0; i < this.wifiScan?.network.length; i++) {
                  this.wifiScan.network[i].find = this.checkInterestedWifi(this.wifiScan.network[i].name, this.wifiScan.network[i].mac);
                  if (this.wifiScan.network[i].find) {
                    this.playNotificationSound('wifi', this.wifiScan.network[i].name + " " + this.wifiScan.network[i].mac);
                  }
                }
              }
              /*
               SCANSIONI BLUETOOTH
              */
              if (parte.startsWith("B")) {
                console.log(atCommand);
                const num_parte = (Number)(parte.replace("B", ""));
                const result = blueResult.parseBlue(atCommand, scannum);
                if (atCommand.indexOf("BT") >= 0 || atCommand.indexOf("bt") >= 0) {
                  if (result == undefined) {
                    console.log(atCommand)
                    this.errorBlue = true;
                    this.scanResultBlue = scannum;
                  } else {
                    this.errorBlue = false;
                    console.log("NUM_PARTE: " + num_parte);
                    console.log("result: " + result.network);
                    if (num_parte == 0) {
                      this.moreBlue = false;
                      this.blueScan = result;
                      this.blueScan.time = new Date();
                      this.listCoordScansioni.push(new ScanMap((Number)(this.blueScan.network[0].signal), "blue", this.longitude, this.latitude));
                      const event = new Event('on-scan-result-coming');
                      document.dispatchEvent(event);
                    } else {
                      for (let i = 0; i < result.network.length; i++) {
                        this.blueScan?.addScan(result.network[i].name, result.network[i].signal, result.network[i].mac, result.network[i].adv_type_, result.network[i].remote_add, result.ScanNumber, false);
                      }
                    }
                    console.log(this.blueScan);
                    this.scanResultBlue = scannum;
                    this.blueScan?.network.sort((x, y) => y.signal - x.signal);

                  }
                }

              }
              if (this.blueScan != undefined && (atCommand.indexOf("end") > 0 || atCommand.indexOf("more") > 0)) {
                for (let i = 0; i < this.blueScan?.network.length; i++) {
                  this.blueScan.network[i].find = this.checkInterestedBluetooth(this.blueScan.network[i].name, this.blueScan.network[i].mac);
                  if (this.blueScan.network[i].find) {
                    this.playNotificationSound('bluetooth', this.blueScan.network[i].name + " " + this.blueScan.network[i].mac);
                  }
                }
              }
            } else {
              /*
              SCANSIONI DAI MODULI
              */
              const atCommand = (String)(jsonData.d ?? jsonData.data);
              const scannum = (Number)(jsonData.num ?? jsonData.surveyNum); // rinominato dalla versione 
              const modem = (Number)(jsonData.ind);
              /* 
              SE MODULO 4G 
              [moduli 1,2,3,4,5] 
              */
              if (JSON.stringify(jsonData).indexOf("ind") >= 0 && (modem == 1 || modem == 3)) {
                this.modem = modem;
                const tp = (String)(jsonData.pt ?? jsonData.tp);
                const type = (String)(tp.charAt(0));
                let i = 1;
                let p = "";
                for (i = 1; i < tp.length; i++) {
                  p += tp.charAt(i);
                }
                const part = (Number)(p);
                const location = [this.longitude, this.latitude];
                let result;
                if (modem == 1) { // H 1,2,3
                  result = ScanResult.parseAtCommandHauwei(atCommand, scannum, part, type, location);
                } else if (modem == 3) { // H 4,5
                  result = ScanResult.parse4GModule(atCommand, scannum, part, type, location);
                }
                // SCANSIONI MODULO 4G
                if (result instanceof ScanResultH) {
                  this.restart_hua = false;
                  // GSM
                  if (type.indexOf("G") >= 0) {
                    if (part == 0) {
                      this.cellHgsm = result;
                      this.cellHgsm.time = new Date();
                      this.netResultG++;
                      if (this.isScanning == true && modem == 1) {
                        this.listCoordScansioni.push(new ScanMap((Number)(this.cellHgsm.Cells[0].power), this.cellHgsm.Technology, (Number)(this.cellHgsm.location[0].toFixed(5)), (Number)(this.cellHgsm.location[1].toFixed(5))));
                        const event = new Event('on-scan-result-coming');
                        document.dispatchEvent(event);
                      }
                    } else {
                      let i = 0;
                      for (i = 0; i < result.Cells.length; i++) {
                        this.cellHgsm?.Cells.push(
                          {
                            cellCode: result.Cells[i].cellCode,
                            band: result.Cells[i].band,
                            arfcn: result.Cells[i].arfcn,
                            power: result.Cells[i].power,
                            operatore: result.Cells[i].operatore,
                            img: result.Cells[i].img,
                            down_frequency: result.Cells[i].down_frequency,
                            find: false,
                          }
                        );
                      }
                      this.cellHgsm?.Cells.sort((x, y) => y.power - x.power);
                    }
                  } else // UMTS
                    if (type.indexOf("U") >= 0) {
                      if (part == 0) {
                        this.cellHumts = result;
                        this.netResultU++;
                        this.cellHumts.time = new Date();
                        if (this.isScanning == true && modem == 1) {
                          this.listCoordScansioni.push(new ScanMap((Number)(this.cellHumts.Cells[0].power), this.cellHumts.Technology, (Number)(this.cellHumts.location[0].toFixed(5)), (Number)(this.cellHumts.location[1].toFixed(5))));
                          const event = new Event('on-scan-result-coming');
                          document.dispatchEvent(event);
                        }
                      } else {
                        let i = 0;
                        for (i = 0; i < result.Cells.length; i++) {
                          this.cellHumts?.Cells.push(
                            {
                              cellCode: result.Cells[i].cellCode,
                              band: result.Cells[i].band,
                              arfcn: result.Cells[i].arfcn,
                              power: result.Cells[i].power,
                              operatore: result.Cells[i].operatore,
                              img: result.Cells[i].img,
                              down_frequency: result.Cells[i].down_frequency,
                              find: false,
                            }
                          );
                        }
                        this.cellHumts?.Cells.sort((x, y) => y.power - x.power);
                      }
                    } else // LTE
                      if (type.indexOf("L") >= 0) {
                        if (part == 0) {
                          this.cellHlte = result;
                          this.cellHlte.time = new Date();
                          this.netResultL++;
                          if (this.isScanning == true && modem == 1) {
                            this.listCoordScansioni.push(new ScanMap((Number)(this.cellHlte.Cells[0].power), this.cellHlte.Technology, (Number)(this.cellHlte.location[0].toFixed(5)), (Number)(this.cellHlte.location[1].toFixed(5))));
                            const event = new Event('on-scan-result-coming');
                            document.dispatchEvent(event);
                          }
                        } else {
                          let i = 0;
                          for (i = 0; i < result.Cells.length; i++) {
                            this.cellHlte?.Cells.push(
                              {
                                cellCode: result.Cells[i].cellCode,
                                band: result.Cells[i].band,
                                arfcn: result.Cells[i].arfcn,
                                power: result.Cells[i].power,
                                operatore: result.Cells[i].operatore,
                                img: result.Cells[i].img,
                                down_frequency: result.Cells[i].down_frequency,
                                find: false,
                              }
                            );
                          }
                          this.cellHlte?.Cells.sort((x, y) => y.power - x.power);
                        }
                      }
                  this.scanResultsH = result.ScanNumber;

                } // SCANSIONI FINE COMANDO AOPS MODULO 4G 
                else if (atCommand.indexOf("END AOPS") >= 0) {
                  if (type.indexOf("G") >= 0 && this.cellHgsm != undefined) {
                    this.cellHgsm?.Cells.sort((x, y) => y.power - x.power);
                    this.listCoordScansioni.push(new ScanMap((Number)(this.cellHgsm?.Cells[0].power), this.cellHgsm.Technology, (Number)(this.cellHgsm?.location[0].toFixed(5)), (Number)(this.cellHgsm?.location[1].toFixed(5))));
                    const event = new Event('on-scan-result-coming');
                    document.dispatchEvent(event);
                  } else if (type.indexOf("U") >= 0 && this.cellHumts != undefined) {
                    this.cellHumts?.Cells.sort((x, y) => y.power - x.power);
                    this.listCoordScansioni.push(new ScanMap((Number)(this.cellHumts?.Cells[0].power), this.cellHumts.Technology, (Number)(this.cellHumts?.location[0].toFixed(5)), (Number)(this.cellHumts?.location[1].toFixed(5))));
                    const event = new Event('on-scan-result-coming');
                    document.dispatchEvent(event);
                  } else if (type.indexOf("L") >= 0 && this.cellHlte != undefined) {
                    this.cellHlte?.Cells.sort((x, y) => y.power - x.power);
                    this.listCoordScansioni.push(new ScanMap((Number)(this.cellHlte?.Cells[0].power), this.cellHlte.Technology, (Number)(this.cellHlte?.location[0].toFixed(5)), (Number)(this.cellHlte?.location[1].toFixed(5))));
                    const event = new Event('on-scan-result-coming');
                    document.dispatchEvent(event);
                  }
                  // interested cell perchè conteggio sbagliato
                  if (type.indexOf("G") >= 0 && this.cellHgsm != undefined) {
                    for (let i = 0; i < this.cellHgsm.Cells.length; i++) {
                      this.cellHgsm.Cells[i].find = this.checkInterestedCell(this.cellHgsm.Cells[i].cellCode);
                      if (this.cellHgsm.Cells[i].find) {
                        this.playNotificationSound('cell', this.cellHgsm.Cells[i].cellCode);
                      }
                    }
                  } else if (type.indexOf("L") >= 0 && this.cellHlte != undefined) {
                    for (let i = 0; i < this.cellHlte.Cells.length; i++) {
                      this.cellHlte.Cells[i].find = this.checkInterestedCell(this.cellHlte.Cells[i].cellCode);
                      if (this.cellHlte.Cells[i].find) {
                        this.playNotificationSound('cell', this.cellHlte.Cells[i].cellCode);
                      }
                    }
                  } else if (this.cellHumts != undefined) {
                    for (let i = 0; i < this.cellHumts.Cells.length; i++) {
                      this.cellHumts.Cells[i].find = this.checkInterestedCell(this.cellHumts.Cells[i].cellCode);
                      if (this.cellHumts.Cells[i].find) {
                        this.playNotificationSound('cell', this.cellHumts.Cells[i].cellCode);
                      }
                    }
                  }
                } // POSIZIONI GPS 
                else if (result instanceof ScanGPS) {
                  this.latitude = result.latitude;
                  this.longitude = result.longitude;
                  this.altitude = Number(result.altitude);
                  this.antennaGPS = true;
                } // SCANSIONI ATTIVE 
                else if (result instanceof ActiveScan) {
                  this.stateActive = 1;
                  if (part == 0) {
                    this.cellScanActive = result;
                    if (this.cellScanActive.Cell.length == 0) {
                      this.activeNONE = true;
                    } else {
                      this.activeNONE = false;
                    }
                    this.scanResultActive++;
                    this.listCoordScansioni.push(new ScanMap((Number)(this.scanResultActive), "active", this.longitude, this.latitude));
                    const event = new Event('on-scan-result-coming');
                    document.dispatchEvent(event);
                  } else {
                    for (let i = 0; i < result.Cell.length; i++) {
                      this.cellScanActive?.addCell(result.Cell[i]);
                    }
                  }
                  if (this.cellScanActive) {
                    for (let i = 0; i < this.cellScanActive.Cell.length; i++) {
                      this.cellScanActive.Cell[i].find = this.checkInterestedCell(this.cellScanActive.Cell[i].cellcode);
                      if (this.cellScanActive.Cell[i].find) {
                        this.playNotificationSound('cell', this.cellScanActive.Cell[i].cellcode);
                      }
                    }
                  }
                }
              }
            }
            this.scanResults = this.scanResultsH + this.scanResultsS + this.scanResultWifi + this.scanResultBlue + this.scanResultActive;
          }
          else {
            const record = CellRecord.fromCsv(str);
            if (record) {
              record.fileName = $BTSTracker.value.fileName;
              $BTSTracker.value.scanResultsS++;
              $BTSTracker.value.scanResultsH++;
              const event = new CustomEvent('new-cell', { detail: record });
              window.dispatchEvent(event);
            }
          }

        } catch (e) {
          console.log("scan Feedback Chara A");
          const rsp = new Int32Array([1]).buffer;
          await BleClient.write($BTSTracker.value.connectedDeviceId.deviceId, COMMAND_SERVICE_ID, SCAN_FEEDBACK_CHARA, new DataView(rsp, 0, rsp.byteLength));
        }
        $BTSTracker.value.availableAt = new Date().getTime();
      }

    } catch (e) {
      console.log(e);
    }
  }

  mergeUnique<T extends { id: any }>(...arrays: T[][]): T[] {
    return Array.from(
      new Map(
        arrays.flat().map(item => [item.id, item]) // Usa `id` come chiave nella Map
      ).values()
    );
  }

  /*
  INIZIALIZZAZIONE INIZIALE 
  SCANSIONI 5G
  */
  async handleScanResultB(result: DataView) {
    if (this.readyForScanning) {
      this.perc = 100;
      this.init = 1;
    }
    try {
      if ($BTSTracker.value.connectedDeviceId) {
        const str = BTSTracker.stringDecoder.decode(result);
        try {
          //console.log(str);
          if (str.startsWith("{")) {
            const jsonData = JSON.parse(str);
            // per celle di interesse
            if (JSON.stringify(jsonData).indexOf("list") >= 0) {
              if (JSON.stringify(jsonData).indexOf("NO CELL") >= 0) {
                this.noInterestedCell = true;
                this.stopSave = true;
              }
              if (JSON.stringify(jsonData).indexOf("END") >= 0) {
                const array_cell = Array.from(
                  new Map(
                    this.interestedCell
                      .map(item => item.parentsInfo) // Extract parentsInfo
                      .filter(info => info !== undefined) // Remove undefined values
                      .map(info => [info.id, info]) // Use id as key in Map
                  ).values()
                );
                const array_wifi = Array.from(
                  new Map(
                    this.interestedWifi
                      .map(item => item.parentsInfo) // Extract parentsInfo
                      .filter(info => info !== undefined) // Remove undefined values
                      .map(info => [info.id, info]) // Use id as key in Map
                  ).values()
                );
                const array_blue = Array.from(
                  new Map(
                    this.interestedBluetooth
                      .map(item => item.parentsInfo) // Extract parentsInfo
                      .filter(info => info !== undefined) // Remove undefined values
                      .map(info => [info.id, info]) // Use id as key in Map
                  ).values()
                );

                this.accordionList = this.mergeUnique(array_cell, array_blue, array_wifi);

                //console.log(this.accordionList);
                this.stopSave = true;
                this.sendCommand("savedAllCell", { "save": true });
              }
              if (this.stopSave == false) {
                //console.log(jsonData);
                this.noInterestedCell = false;
                const resp = jsonData.list.split(";");
                console.log(resp);
                if (resp.length > 6) {
                  const cell_int = new cell(resp[2], resp[3], resp[4], resp[5]);
                  cell_int.tec = resp[6];
                  cell_int.location.lat = (Number)(resp[7]);
                  cell_int.location.long = (Number)(resp[8]);
                  cell_int.az = (Number)(resp[9]);
                  cell_int.bh = (Number)(resp[10]);
                  const code = new searchCell(resp[0], cell_int);
                  code.source = resp[1];
                  if (code.source == "auto") code.view = true;
                  code.valueQrCode = resp[10];
                  if (resp.length > 12) {
                    code.parentsInfo = new accordionListItem((Number)(resp[12]));
                    code.parentsInfo.name = resp[13];
                  } else {
                    code.parentsInfo = new accordionListItem(0);
                  }
                  this.interestedCell.push(code);
                }
                if (resp[resp.length - 1].indexOf("B") >= 0) {
                  // bluetooth
                  const item = new wirelessNetwork(resp[1], resp[0]);
                  item.hide = false;
                  item.parentsInfo.hide = false;
                  item.parentsInfo.id = (Number)(resp[2]);
                  item.parentsInfo.name = resp[3];
                  this.interestedBluetooth.push(item);
                } else if (resp[resp.length - 1].indexOf("W") >= 0) {
                  // wifi
                  const item = new wirelessNetwork(resp[1], resp[0]);
                  item.hide = false;
                  item.parentsInfo.hide = false;
                  item.parentsInfo.id = (Number)(resp[2]);
                  item.parentsInfo.name = resp[3];
                  this.interestedWifi.push(item);
                }
              }
            }
            // per inizializzazione veloce e immediata
            if (JSON.stringify(jsonData).indexOf("check") >= 0) {
              $BTSTracker.value.modA = Number(jsonData.mod1);
              $BTSTracker.value.modB = Number(jsonData.mod2);
              $BTSTracker.value.perc = Number(jsonData.perc);
              $BTSTracker.value.moduleWifi = Number(jsonData.wifi);
              if ($BTSTracker.value.moduleWifi == 1 && $BTSTracker.value.isScanning == false) {
                $BTSTracker.value.wifi = true;
                $BTSTracker.value.blue = true;
              } else if ($BTSTracker.value.moduleWifi == 0 && $BTSTracker.value.isScanning == false) {
                $BTSTracker.value.wifi = true; $BTSTracker.value.blue = false;
              }
            } else if (JSON.stringify(jsonData).indexOf("count") >= 0) {
              //console.log(jsonData);
              $BTSTracker.value.numSim = (Number)(jsonData.count);
              $BTSTracker.value.simH = (jsonData.a1);
              $BTSTracker.value.simS1 = (jsonData.b1);
              $BTSTracker.value.simS2 = (jsonData.b2);
              this.setOperatori();
              $BTSTracker.value.pin1 = (jsonData.p1);
              $BTSTracker.value.pin2 = (jsonData.p2);
              if ($BTSTracker.value.pin1.indexOf("/") >= 0) {
                $BTSTracker.value.pin1 = "";
              }
              if ($BTSTracker.value.pin2.indexOf("/") >= 0) {
                $BTSTracker.value.pin2 = "";
              }
              if ($BTSTracker.value.simS1.length > 0) {
                $BTSTracker.value.slot1 = true;
              } else {
                $BTSTracker.value.slot1 = false;
              }
              if ($BTSTracker.value.simS2.length > 0) {
                $BTSTracker.value.slot2 = true;
              } else {
                $BTSTracker.value.slot2 = false;
              }
              if ($BTSTracker.value.simS1.length == 0) {
                //console.log("non c'è 1");
                this.imsi1_old = "";
                this.apn1 = "";
                this.userApn1 = "";
                this.passApn1 = "";
              }
              if ($BTSTracker.value.simS2.length == 0) {
                //console.log("non c'è 2");
                this.imsi2_old = "";
                this.apn2 = "";
                this.userApn2 = "";
                this.passApn2 = "";
              }
              if (this.simS1.length == 0 && this.simS2.length == 0) {
                this.connectedCell = false;
              }
              if (this.check == false) {
                if (this.simH.length > 0 && !this.isScanning) {
                  this.activeSet = true; this.availableCell = false;
                  this.check = true;
                } else if (!this.isScanning) {
                  this.activeSet = false; this.availableCell = true;
                }
              }

              this.perc = 100;
              this.init = 1;
              this.readyForScanning = true;

            } else if (JSON.stringify(jsonData).indexOf("ATD") >= 0) {
              console.log(jsonData);
              // risposta TEST CALL
              if (JSON.stringify(jsonData).indexOf("SIM 1") >= 0) {
                jsonData.d = jsonData.d.replace("SIM 1", "");
                this.responseCallTest1 = jsonData.d.split("|");
                for (let i = 0; i < this.responseCallTest1.length; i++) {
                  this.responseCallTest1[i] = this.responseCallTest1[i].replaceAll(';', '');
                }
                this.waitingForCallTest1 = false;
                console.log(this.responseCallTest1);
              }
              if (JSON.stringify(jsonData).indexOf("SIM 2") >= 0) {
                jsonData.d = jsonData.d.replace("SIM 2", "");
                this.responseCallTest2 = jsonData.d.split("|");
                for (let i = 0; i < this.responseCallTest2.length; i++) {
                  this.responseCallTest2[i] = this.responseCallTest2[i].replaceAll(';', '');
                }
                this.waitingForCallTest2 = false;
              }

              if (this.waitingForCallTest1 == false && this.waitingForCallTest2 == false && this.scanOnlyCall == true) {
                this.startCallTest = false;
                await this.sendCommand("stop_scan", {}).then(l => {
                  //console.log("SCAN STOPPATA -->" + l);
                });
                this.scanOnlyCall = false;
              } else if (this.waitingForCallTest1 == false && this.waitingForCallTest2 == false) {
                this.startCallTest = false;
              }

            } else {
              // RISPOSTE MODULI
              const atCommand = (String)(jsonData.d ?? jsonData.data);
              const scannum = (Number)(jsonData.num ?? jsonData.surveyNum); // rinominato dalla versione 
              const modem = (Number)(jsonData.ind);

              // [modem B,C,D]
              let part = "00";
              part = (String)(jsonData.pt ?? jsonData.tp);
              const location = [this.longitude, this.latitude];
              //console.warn(atCommand);
              const scanResult = ScanResult.parseFromAtCommand(atCommand, scannum, location);
              // CELLE CONNESSE
              if (scanResult) {
                if (scanResult instanceof ScanResultS_5GNSA) {
                  this.scanResultsS = scanResult.ScanNumber + 1;
                  if (part.indexOf("00") >= 0 || part.indexOf("10") >= 0) {
                    this.cell5GNSA = scanResult;
                    this.state5GNSA = 1;
                    this.state5GSA = 0;
                    this.stateLTE = 0;
                    this.stateNO = 0;
                    this.stateWcdma = 0;
                    this.countCellB1++;
                    this.cell5GNSA.lte.find = this.checkInterestedCell(this.cell5GNSA.lte.cellcode);
                    if (this.cell5GNSA.find) this.playNotificationSound('cell', this.cell5GNSA.lte.cellcode);
                    this.cell5GNSA.lte.find2 = this.checkInterestedCell(this.cell5GNSA.lte.cellcodeS);
                    if (this.cell5GNSA.find2) this.playNotificationSound('cell', this.cell5GNSA.lte.cellcodeS);
                  } else {
                    this.cell5GNSA2 = scanResult;
                    this.state5GNSA2 = 1;
                    this.state5GSA2 = 0;
                    this.stateLTE2 = 0;
                    this.stateWcdma2 = 0;
                    this.stateNO2 = 0;
                    this.countCellB2++;
                    this.cell5GNSA2.lte.find = this.checkInterestedCell(this.cell5GNSA2.lte.cellcode);
                    if (this.cell5GNSA2.find) this.playNotificationSound('cell', this.cell5GNSA2.lte.cellcode);
                    this.cell5GNSA2.lte.find2 = this.checkInterestedCell(this.cell5GNSA2.lte.cellcodeS);
                    if (this.cell5GNSA2.find2) this.playNotificationSound('cell', this.cell5GNSA2.lte.cellcodeS);
                  }
                } else if (scanResult instanceof ScanResultS_5GSA) {
                  this.scanResultsS = scanResult.ScanNumber + 1;
                  if (part.indexOf("00") >= 0 || part.indexOf("10") >= 0) {
                    this.cell5GSA = scanResult;
                    this.state5GSA = 1;
                    this.state5GNSA = 0;
                    this.stateLTE = 0;
                    this.stateWcdma = 0;
                    this.stateNO = 0;
                    this.countCellB1++;
                    this.cell5GSA.find = this.checkInterestedCell(this.cell5GSA.cellcode);
                    if (this.cell5GSA.find) this.playNotificationSound('cell', this.cell5GSA.cellcode);
                  } else {
                    this.cell5GSA2 = scanResult;
                    this.state5GNSA2 = 0;
                    this.state5GSA2 = 1;
                    this.stateLTE2 = 0;
                    this.stateWcdma2 = 0;
                    this.stateNO2 = 0;
                    this.countCellB2++;
                    this.cell5GSA2.find = this.checkInterestedCell(this.cell5GSA2.cellcode);
                    if (this.cell5GSA2.find) this.playNotificationSound('cell', this.cell5GSA2.cellcode);
                  }
                } else if (scanResult instanceof ScanResultS_lte) {
                  this.scanResultsS = scanResult.ScanNumber + 1;
                  if (part.indexOf("00") >= 0 || part.indexOf("10") >= 0) {
                    this.cellLTE = scanResult;
                    this.stateLTE = 1;
                    this.state5GSA = 0;
                    this.state5GNSA = 0;
                    this.stateNO = 0;
                    this.stateWcdma = 0;
                    this.countCellB1++;
                    this.cellLTE.find = this.checkInterestedCell(this.cellLTE.cellcode);
                    if (this.cellLTE.find) this.playNotificationSound('cell', this.cellLTE.cellcode);
                    this.cellLTE.find2 = this.checkInterestedCell(this.cellLTE.cellcodeS);
                    if (this.cellLTE.find2) this.playNotificationSound('cell', this.cellLTE.cellcodeS);
                  } else {
                    this.cellLTE2 = scanResult;
                    this.state5GNSA2 = 0;
                    this.state5GSA2 = 0;
                    this.stateLTE2 = 1;
                    this.stateNO2 = 0;
                    this.stateWcdma2 = 0;
                    this.countCellB2++;
                    this.cellLTE2.find = this.checkInterestedCell(this.cellLTE2.cellcode);
                    if (this.cellLTE2.find) this.playNotificationSound('cell', this.cellLTE2.cellcode);
                    this.cellLTE2.find2 = this.checkInterestedCell(this.cellLTE2.cellcodeS);
                    if (this.cellLTE2.find2) this.playNotificationSound('cell', this.cellLTE2.cellcodeS);
                  }
                } else if (scanResult instanceof ScanResultS_noService) {
                  this.scanResultsS = scanResult.ScanNumber + 1;
                  if (part.indexOf("00") >= 0 || part.indexOf("10") >= 0) {
                    this.cellNoSer = scanResult;
                    this.stateNO = 1;
                    this.state5GSA = 0;
                    this.state5GNSA = 0;
                    this.stateWcdma = 0;
                    this.stateLTE = 0;
                    this.countCellB1++;
                  } else {
                    this.cellNoSer2 = scanResult; this.state5GNSA2 = 0;
                    this.state5GSA2 = 0;
                    this.stateLTE2 = 0;
                    this.stateWcdma2 = 0;
                    this.stateNO2 = 1;
                    this.countCellB2++;
                  }
                } else if (scanResult instanceof ScanResultS_wcdma) {
                  this.scanResultsS = scanResult.ScanNumber + 1;
                  if (part.indexOf("00") >= 0 || part.indexOf("10") >= 0) {
                    this.cellwcdma = scanResult;
                    this.stateNO = 0;
                    this.state5GSA = 0;
                    this.state5GNSA = 0;
                    this.stateWcdma = 1;
                    this.stateLTE = 0;
                    this.countCellB1++;
                    this.cellwcdma.find = this.checkInterestedCell(this.cellwcdma.cellcodeS);
                    if (this.cellwcdma.find) this.playNotificationSound('cell', this.cellwcdma.cellcodeS);
                  } else {
                    this.cellwcdma2 = scanResult;
                    this.state5GNSA2 = 0;
                    this.state5GSA2 = 0;
                    this.stateLTE2 = 0;
                    this.stateWcdma2 = 1;
                    this.stateNO2 = 0;
                    this.countCellB2++;
                    this.cellwcdma2.find = this.checkInterestedCell(this.cellwcdma2.cellcodeS);
                    if (this.cellwcdma2.find) this.playNotificationSound('cell', this.cellwcdma2.cellcodeS);
                  }
                } else if (scanResult instanceof ScanResultH) {
                  this.scanResultsH = scanResult.ScanNumber;
                  if (this.isScanning == true) {
                    this.listCoordScansioni.push(new ScanMap(1, "", (Number)($BTSTracker.value.longitude.toFixed(5)), (Number)($BTSTracker.value.latitude.toFixed(5))));
                  }
                } else if (scanResult instanceof ScanGPS) {
                  this.latitude = scanResult.latitude;
                  this.longitude = scanResult.longitude;
                  this.altitude = Number(scanResult.altitude);
                }
              }
              this.scanResults = this.scanResultsH + this.scanResultsS + this.scanResultWifi + this.scanResultBlue + this.scanResultActive;
              const conta = 0;
            }
          }
          else {
            const record = CellRecord.fromCsv(str);
            if (record) {
              record.fileName = $BTSTracker.value.fileName;
              $BTSTracker.value.scanResultsS++;
              $BTSTracker.value.scanResultsH++;
              const event = new CustomEvent('new-cell', { detail: record });
              window.dispatchEvent(event);
            }
          }

        } catch (e) {
          //console.log("scan Feedback Chara B");
          const rsp = new Int32Array([1]).buffer;
          await BleClient.write($BTSTracker.value.connectedDeviceId.deviceId, COMMAND_SERVICE_ID, SCAN_FEEDBACK_CHARA, new DataView(rsp, 0, rsp.byteLength));
        }
        $BTSTracker.value.availableAt = new Date().getTime();
      }
    } catch (e) {
      //console.log(e);
    }
  }

  // trovare celle di interesse
  checkInterestedCell(CellCode: string): boolean {
    let find = false;
    const cell = CellCode.split("-");
    for (let i = 0; i < this.interestedCell.length; i++) {
      if (this.interestedCell[i].hide == false) {
        if (this.interestedCell[i].source == "manual_values") {
          if (this.interestedCell[i].cellcode.mcc.length > 0 && cell[0].indexOf(this.interestedCell[i].cellcode.mcc) >= 0) {
            find = true;
            this.interestedCell[i].find = true; this.interestedCell[i].count++;
          }
          if (this.interestedCell[i].cellcode.mnc.length > 0 && cell[1].indexOf(this.interestedCell[i].cellcode.mnc) >= 0) {
            find = true;
            this.interestedCell[i].find = true; this.interestedCell[i].count++;
          }
          if (this.interestedCell[i].cellcode.lac.length > 0 && cell[2].indexOf(this.interestedCell[i].cellcode.lac) >= 0) {
            find = true;
            this.interestedCell[i].find = true; this.interestedCell[i].count++;
          }
          if (this.interestedCell[i].cellcode.cellid.length > 0 && cell[3].indexOf(this.interestedCell[i].cellcode.cellid) >= 0) {
            find = true;
            this.interestedCell[i].find = true; this.interestedCell[i].count++;
          }
        } else {
          if (this.interestedCell[i].name == CellCode) {
            find = true;
            this.interestedCell[i].find = true; this.interestedCell[i].count++;
          }
        }
      }
    }
    return find;
  }

  // trovare wifi 
  checkInterestedWifi(name: string, mac: string): boolean {
    let find = false;
    for (let i = 0; i < this.interestedWifi.length; i++) {
      if (this.interestedWifi[i].hide == false) {
        if (this.interestedWifi[i].name.length > 0 && name.toUpperCase().indexOf(this.interestedWifi[i].name.toUpperCase()) >= 0) { find = true; this.interestedWifi[i].find = true; this.interestedWifi[i].count++; }
        if (this.interestedWifi[i].macAddress.length > 0 && mac.toUpperCase().indexOf(this.interestedWifi[i].macAddress.toUpperCase()) >= 0) { find = true; this.interestedWifi[i].find = true; this.interestedWifi[i].count++; }
      }
    }
    return find;
  }
  //trovare bluetooth
  checkInterestedBluetooth(name: string, mac: string) {
    let find = false;
    for (let i = 0; i < this.interestedBluetooth.length; i++) {
      if (this.interestedBluetooth[i].hide == false) {
        if (this.interestedBluetooth[i].name.length > 0 && name.indexOf(this.interestedBluetooth[i].name) >= 0) { find = true; this.interestedBluetooth[i].find = true; this.interestedBluetooth[i].count++; }
        if (this.interestedBluetooth[i].macAddress.length > 0 && mac.indexOf(this.interestedBluetooth[i].macAddress) >= 0) { find = true; this.interestedBluetooth[i].find = true; this.interestedBluetooth[i].count++; }
      }
    }
    return find;
  }

  playNotificationSound(type: string, name: string): void {
    if (!this.notificationAudio) {
      this.notificationAudio = new Audio('/notification.mp3')
      this.notificationAudio.preload = 'auto'
    }

    // Riavvia da inizio ogni volta
    this.notificationAudio.currentTime = 0

    this.notificationAudio.play().catch((err) => {
      console.warn('Impossibile riprodurre il suono di notifica:', err)
      return;
    })

    let mex = "";
    if (type == 'cell') {
      mex = "createToast.foundCell";
    } else if (type == 'wifi') {
      mex = "createToast.foundWifi";
    } else {
      mex = "createToast.foundBlue";
    }

    createToast(
      {
        title: i18next.t(mex) + ": " + name,
      },
      {
        type: 'success',
        showIcon: true,
        hideProgressBar: true,
      });
  }

  handleCommandFeedback(result: DataView) {
    if ($BTSTracker.value.connectedDeviceId) {
      const str = BTSTracker.stringDecoder.decode(result);
      //console.log(str);
      if ($BTSTracker.value.currentCommandObject) {
        try {
          const obj = JSON.parse(str);
          $BTSTracker.value.currentCommandObject.commandResolverOk(obj); // resolve the promise
          if (obj.ok) {
            if (obj.msg === "scan_started") {
              $BTSTracker.value.isScanning = true;
            }
            if (obj.msg === "scan_stopped") {
              $BTSTracker.value.isScanning = false;
            }
          }
        } catch (e) {
          //console.error(e);
          //console.warn("This is the json with troubles " + str);
        }
        $BTSTracker.value.currentCommandObject = undefined;

      } else {
        //console.log("Receiving command feedback but no resolver");
      }
    } else {
      //console.log("Receiving command feedback but not waiting for it");
    }
  }

  async updateInfos() {
    // BATTERIA
    this.getBattery();

    // GET INFO CELL
    if (this.startScan) {
      const cell: Record<string, any> = await this.sendCommand("get_cell", {});
      console.log(JSON.stringify(cell));
      if (cell.ok) {
        this.cellList = String(cell.msg.cell);
      }
    }

    if (!this.connected || !this.connectedDeviceId) return;
    if (this.appLocation)
      this.sendLocationToBtsTracker(this.appLocation);

    // SET TIME
    await this.sendCommand("set_time_device", { "time": this.deviceDataTime });


    // RESTART
    const restart: Record<string, any> = await this.sendCommand("restart", {});
    //console.log(restart);
    if (restart && restart.ok == true) {
      this.restart = true;
      this.fileName = String(restart.msg.name);
      const technology = String(restart.msg.type);
      this.technologies = technology.split(',');
      this.modeS = String(restart.msg.mode);
      if (this.technologies.indexOf("AutoConnection5G") >= 0) {
        this.connectedCell = true;
        if (this.modeS == '2' || this.modeS == '54' || this.modeS == '55') {
          this.fallback = true;
        } else {
          this.fallback = false;
        }
        if (this.modeS == '14') {
          this.autoConnection = 'UMTS';
        }
        if (this.modeS == '38' || this.modeS == '54') {
          this.autoConnection = 'LTE';
          this.fallback = true;
        }
        if (this.modeS == '71' || this.modeS == '55') {
          this.autoConnection = '5G';
        }
      } else {
        this.connectedCell = false;
      }
      //console.log(this.connectedCell)
      if (this.technologies.indexOf("LTE") >= 0 || this.technologies.indexOf("UMTS") >= 0 || this.technologies.indexOf("GSM") >= 0) {
        this.availableCell = true;
      } else {
        this.availableCell = false;
      }
      if (this.technologies.indexOf("wifi") >= 0) {
        this.wifi = true;
      } else {
        this.wifi = false;
      }
      if (this.technologies.indexOf("blue") >= 0) {
        this.blue = true;
      } else {
        this.blue = false;
      }
      if (this.technologies.indexOf("active") >= 0) {
        this.activeSet = true;
      } else {
        this.activeSet = false;
      }
      this.isScanning = true;

      await this.sendCommand("setLimit", {
        "limitWifi": this.wifiLimit,
        "limitBlue": this.blueLimit
      }).then(l => {
        console.log("sent");
      });
    }

    const scanning = await this.sendCommand("is_scanning", {}); // ask for the status of the scanner
    const msg = "" + scanning.msg as string;
    //console.warn(scanning)
    if (scanning.ok && msg.length > 1) {
      const splitted = msg.split(";");
      if (splitted[0] == "scanning" && this.restart == false) {
        this.NameFile = splitted[2];
        if (this.NameFile.endsWith(".scscan")) {
          this.NameFile = this.NameFile.substring(0, this.NameFile.length - 7);
        }
        if (splitted.length > 3) {
          this.timeStartScan = splitted[3];
        }
        this.technologies = [];
        splitted[1].split(",").forEach(tech => {
          this.technologies.push(tech);
        });
        //console.log(this.technologies);
        if (this.technologies.indexOf("GSM") >= 0 || this.technologies.indexOf("LTE") >= 0 || this.technologies.indexOf("UMTS") >= 0) {
          this.availableCell = true;
        } else {
          this.availableCell = false;
        }
        if (this.technologies.indexOf("AutoConnection5G") >= 0) {
          this.connectedCell = true;
        } else {
          this.connectedCell = false;
        }
        if (this.technologies.indexOf("wifi") >= 0) {
          this.wifi = true;
        } else {
          this.wifi = false;
        }
        if (this.technologies.indexOf("blue") >= 0) {
          this.blue = true;
        } else {
          this.blue = false;
        }
        if (this.technologies.indexOf("active") >= 0) {
          this.activeSet = true;
        } else {
          this.activeSet = false;
        }
        if (this.technologies.indexOf("call") >= 0) {
          // se è solo chiamata di test senza alcun tipo di tecnologia
          this.scanOnlyCall = true;
        } else {
          this.scanOnlyCall = false;
        }
        this.isScanning = true;
      }
      if (this.init == 0) {
        this.readyForScanning = false;
      } else {
        this.readyForScanning = true;
      }
    } else {
      this.isScanning = false;
    }

    // INFO
    const getinfoBtsJson: Record<string, any> = await this.sendCommand("get_btsinfo_json", {});
    //console.log(getinfoBtsJson);
    if (getinfoBtsJson && getinfoBtsJson.ok) {
      if (getinfoBtsJson.msg.deviceSerial) {
        $BTSTracker.value.serial = String(getinfoBtsJson.msg.deviceSerial);
        $BTSTracker.value.version = String(getinfoBtsJson.msg.fwVersion);
      }
      // DATE
      $BTSTracker.value.datetime = String(getinfoBtsJson.msg.date);
      const dt = $BTSTracker.value.datetime.split("T");
      $BTSTracker.value.deviceData = dt[0];
      $BTSTracker.value.deviceTime = dt[1];
      const d = $BTSTracker.value.deviceData.split("-");
      const h = $BTSTracker.value.deviceTime.split(":");

      $BTSTracker.value.modA = Number(getinfoBtsJson.msg.mod1);
      $BTSTracker.value.modB = Number(getinfoBtsJson.msg.mod2);

      $BTSTracker.value.numSim = (Number)(getinfoBtsJson.msg.count);
      $BTSTracker.value.simH = (getinfoBtsJson.msg.a1);
      $BTSTracker.value.simS1 = (getinfoBtsJson.msg.b1);
      $BTSTracker.value.simS2 = (getinfoBtsJson.msg.b2);
      this.setOperatori();
      $BTSTracker.value.pin1 = (getinfoBtsJson.msg.p1);
      $BTSTracker.value.pin2 = (getinfoBtsJson.msg.p2);
      if ($BTSTracker.value.pin1.indexOf("/") >= 0) {
        $BTSTracker.value.pin1 = "";
      }
      if ($BTSTracker.value.pin2.indexOf("/") >= 0) {
        $BTSTracker.value.pin2 = "";
      }
      if ($BTSTracker.value.simS1.length > 0) {
        $BTSTracker.value.slot1 = true;
      } else {
        $BTSTracker.value.slot1 = false;
      }
      if ($BTSTracker.value.simS2.length > 0) {
        $BTSTracker.value.slot2 = true;
      } else {
        $BTSTracker.value.slot2 = false;
      }

      if (this.perc == 0) {
        this.perc = 20;
      }

      if ($BTSTracker.value.simS1.length == 0) {
        //console.log("non c'è 1");
        this.imsi1_old = "";
        this.apn1 = "";
        this.userApn1 = "";
        this.passApn1 = "";
      }
      if ($BTSTracker.value.simS2.length == 0) {
        //console.log("non c'è 2");
        this.imsi2_old = "";
        this.apn2 = "";
        this.userApn2 = "";
        this.passApn2 = "";
      }
      //console.log(this.apn2);
      if (this.simS1.length == 0 && this.simS2.length == 0) {
        this.connectedCell = false;
      }
      if (this.check == false) {
        if (this.simH.length > 0 && !this.isScanning) {
          this.activeSet = true; this.availableCell = false;
          this.check = true;
        } else if (!this.isScanning) {
          this.activeSet = false; this.availableCell = true;
        }
      }

      $BTSTracker.value.moduleWifi = Number(getinfoBtsJson.msg.wifi_module);
      if ($BTSTracker.value.moduleWifi == 1 && $BTSTracker.value.isScanning == false) {
        $BTSTracker.value.wifi = true;
        $BTSTracker.value.blue = true;
      } else if ($BTSTracker.value.moduleWifi == 0 && $BTSTracker.value.isScanning == false) {
        $BTSTracker.value.wifi = true; $BTSTracker.value.blue = false;
      }
    }

    this.updateSettings();

    const getinfoJson: Record<string, any> = await this.sendCommand("get_info_json", {});
    //console.log(getinfoJson)
    //SD
    if (this.updateSD == false) {
      $BTSTracker.value.sdCardError = Boolean(getinfoJson.msg.error);
      if (!$BTSTracker.value.sdCardError) {
        $BTSTracker.value.sdCardTotalSize = Number(getinfoJson.msg.full);
        $BTSTracker.value.sdCardUsedSize = Number(getinfoJson.msg.used);
      } else {
        $BTSTracker.value.sdCardTotalSize = 0;
        $BTSTracker.value.sdCardUsedSize = 0;
      }

      this.caricamentoSD = false;
    }

    if (JSON.stringify(getinfoJson).indexOf("v") >= 0) {
      const modules = getinfoJson.msg.v.split(";");
      if (this.modA == 1) {
        this.moduleA = modules[0];
      }
      if (this.modB == 1) {
        this.moduleB = modules[1];
      }
    }
    if (getinfoJson && getinfoJson.ok == true) {
      $BTSTracker.value.init = Number(getinfoJson.msg.init);

      if ($BTSTracker.value.init == 1 && $BTSTracker.value.moduleWifi != -1) {
        $BTSTracker.value.perc = 100;
        $BTSTracker.value.readyForScanning = true;
      } else if (this.init != 1) {
        $BTSTracker.value.perc = Number(getinfoJson.msg.perc);
      }

    }
    if ($BTSTracker.value.init == 1 && $BTSTracker.value.moduleWifi != -1) {
      $BTSTracker.value.readyForScanning = true;
    }

  }

  async getBattery() {
    const batteryPercentagesjson: Record<string, any> = await this.sendCommand("get_battery_json", {});
    console.log("BATTERY: " + batteryPercentagesjson.msg.media);
    if (batteryPercentagesjson && batteryPercentagesjson.ok == true) {
      $BTSTracker.value.millivolts = Number(batteryPercentagesjson.msg.Millivolts);
      $BTSTracker.value.currVoltage = Number(batteryPercentagesjson.msg.currVoltage);
      $BTSTracker.value.usbConnected = Number(batteryPercentagesjson.msg.usbConnected);
      $BTSTracker.value.acok = Number(batteryPercentagesjson.msg.acok);
      $BTSTracker.value.batteryPercentage = Number(batteryPercentagesjson.msg.level);
      if ($BTSTracker.value.batteryPercentage < 0)
        $BTSTracker.value.batteryPercentage = 0;
      if ($BTSTracker.value.batteryPercentage > 100)
        $BTSTracker.value.batteryPercentage = 100;
      $BTSTracker.value.mediaBatteria = batteryPercentagesjson.msg.media;
      if ($BTSTracker.value.mediaBatteria < 0)
        $BTSTracker.value.mediaBatteria = 0;
      if ($BTSTracker.value.mediaBatteria > 100)
        $BTSTracker.value.mediaBatteria = 100;
    }
  }

  async updateSDCard() {
    const getsd: Record<string, any> = await this.sendCommand("get_sdCard", {});
    if (getsd && getsd.ok) {
      //SD
      $BTSTracker.value.sdCardError = Boolean(getsd.msg.error);
      $BTSTracker.value.sdCardTotalSize = Number(getsd.msg.full);
      $BTSTracker.value.sdCardUsedSize = Number(getsd.msg.used);
      this.caricamentoSD = false;
      this.updateSD = false;
    }
  }

  async apn_ftp() {
    //console.warn("apn");
    const getApn: Record<string, any> = await this.sendCommand("get_apn", {});
    //console.warn(getApn);
    if (getApn.ok && this.isScanning == false) {
      //console.log("here");
      this.apnSettings = true;
      this.imsi1_old = String(getApn.msg.imsi1);

      this.apn1 = String(getApn.msg.APN1);
      this.userApn1 = String(getApn.msg.uAPN1);
      this.passApn1 = String(getApn.msg.pAPN1);
      this.imsi2_old = String(getApn.msg.imsi2);

      this.apn2 = String(getApn.msg.APN2);
      this.userApn2 = String(getApn.msg.uAPN2);
      this.passApn2 = String(getApn.msg.pAPN2);

      //console.log(this.apn1);

      if (this.simS1.length > 0 && this.simS2.length > 0) {
        if (this.apn1.length == 0) {
          this.sceltaSim = "2";
        } else {
          this.sceltaSim = "1";
        }
      } else {
        if (this.simS1.length > 0 && this.apn1.length > 0) {
          this.sceltaSim = "1";
        }
        if (this.simS2.length > 0 && this.apn2.length > 0) {
          this.sceltaSim = "2";
        }
      }

    } else {
      this.apnSettings = true;
    }
    if (getApn.ok) {
      if (this.init == 1 && this.checkimsi == true && this.atLeastAsim()) {
        if (this.imsi1_old != this.simS1) {
          this.differentSim1 = true;
          createToast({
            title: i18next.t("createToast.sim1Diff"),
            description: i18next.t("createToast.simDiffDesc"),
          }, {
            type: 'warning',
            showIcon: true,
            hideProgressBar: true,
          });
        }
        if (this.imsi2_old != this.simS2) {
          this.differentSim2 = true;
          createToast({
            title: i18next.t("createToast.sim2Diff"),
            description: i18next.t("createToast.simDiffDesc"),
          }, {
            type: 'warning',
            showIcon: true,
            hideProgressBar: true,
          });
        }
        this.checkimsi = false;
      }
    }
    if (this.apn1.length > 0 && this.APNlist.indexOf("B1") < 0) {
      this.APNlist += "B1 "
    }
    if (this.apn2.length > 0 && this.APNlist.indexOf("B2") < 0) {
      this.APNlist += "B2";
    }
    if (this.apn1.length == 0 && this.apn2.length == 0) {
      this.APNlist = "";
    }

    //console.log(this.APNlist)

    const getFtp: Record<string, any> = await this.sendCommand("get_ftp", {});
    if (this.ftpSettings == false) {
      if (getFtp.ok && JSON.stringify(getApn.msg).length > 2 && this.staticInfo == false) {
        this.ftpSettings = true;
        this.ftp = String(getFtp.msg.FTP);
        this.userFtp = String(getFtp.msg.uFTP);
        this.passFtp = String(getFtp.msg.pFTP);
        if (this.ftp.length == 0) {
          this.enableapn = false;
        }
      } else {
        this.ftpSettings = true;
      }
    }
  }

  async updateSettings() {
    //console.log(this.isScanning);
    if (this.isScanning == false) {
      this.apn_ftp();
      const otaError = await this.sendCommand("get_error", {});
      if (otaError.ok) {
        const s = (otaError.msg as string).split(";");
        $BTSTracker.value.errorOta = s[0];
      }
    }
  }

  setOperatori() {
    const mcc_mnc1 = this.simS1.slice(0, 3) + "-" + this.simS1.slice(3, 5);
    this.opeSim1 = ScanResult.getOperatore(mcc_mnc1);
    const mcc_mnc2 = this.simS2.slice(0, 3) + "-" + this.simS2.slice(3, 5);
    this.opeSim2 = ScanResult.getOperatore(mcc_mnc2);
    const mcc_mnc0 = this.simH.slice(0, 3) + "-" + this.simH.slice(3, 5);
    this.opeSim0 = ScanResult.getOperatore(mcc_mnc0);
  }

  async getResponceAPN() {
    const getInfo: Record<string, any> = await this.sendCommand("get_responceApn", {});
    if (this.apn1.length > 0 && this.APNlist.indexOf("B1") < 0) {
      this.APNlist += "B1 "
    }
    if (this.apn2.length > 0 && this.APNlist.indexOf("B2") < 0) {
      this.APNlist += "B2";
    }
    if (this.apn1.length == 0 && this.apn2.length == 0) {
      this.APNlist = "";
    }
    //console.log(this.APNlist)
    if (getInfo.ok) {
      createToast({
        title: i18next.t("createToast.apnSave"),
      }, {
        type: 'success',
        showIcon: true,
        hideProgressBar: true,
      });
    } else {
      createToast({
        title: i18next.t("createToast.errApnSave"),
      }, {
        type: 'danger',
        showIcon: true,
        hideProgressBar: true,
      });
    }
    this.apnSettings = true;
  }

  async getResponceFTP() {
    const getInfo: Record<string, any> = await this.sendCommand("get_responceFtp", {});
    if (getInfo.ok) {
      createToast({
        title: i18next.t("createToast.ftpSave"),
      }, {
        type: 'success',
        showIcon: true,
        hideProgressBar: true,
      });
    } else {
      createToast({
        title: i18next.t("createToast.errFtpSave"),
      }, {
        type: 'danger',
        showIcon: true,
        hideProgressBar: true,
      });
    }
    this.ftpSettings = true;
  }

  public atLeastAsim() {
    if (this.simS1.length > 0 || this.simS2.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  public atLeastAapn() {
    if (this.apn1.length > 0 || this.apn2.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  public async sendCommand(cmd: string, data: Record<string, unknown>): Promise<Record<string, unknown>> {
    if (!this.connected || !this.connectedDeviceId) throw "Not connected";
    const object = {
      "cmd": cmd,
    } as Record<string, unknown>;
    if (Object.keys(data).length > 0) object["data"] = data; // put the data only if it's not empty

    let rsv: (a: Record<string, unknown>) => void = () => { return; }; // create the resolver
    const prm = new Promise<Record<string, unknown>>((resolve) => rsv = resolve); // create the promise
    const commandObj = new Command(object, rsv); // create the command object
    this.commands.push(commandObj); // add the command to the commands queue
    if (!this.connected || !this.connectedDeviceId) throw "Not connected";
    return prm; // return the promise
  }

  public async disconnect() {
    if ($BTSTracker.value.connected && $BTSTracker.value.connectedDeviceId) {
      try {
        await BleClient.disconnect($BTSTracker.value.connectedDeviceId.deviceId);
      } catch (e) {
        // ignored
      }
      $BTSTracker.value.connectedDeviceId = undefined;
      $BTSTracker.value.connected = false;
      $BTSTracker.value.connecting = false;
      this.caricamentoSD = true;
    }
  }

  public isConnected(): boolean {
    return $BTSTracker.value.connected;
  }

  public getbatteryPercentage(): number {
    return $BTSTracker.value.mediaBatteria;
  }

  public async openFile(fileConvert?: FolderContainer) {
    let file: FolderContainer | undefined;
    if (fileConvert != undefined) {
      file = fileConvert;
    } else if (fileConvert == undefined && this.file != undefined) {
      file = this.file;
    }
    if (file == undefined) return;
    console.log(file);
    if (this.isScanning == true) {
      this.stopScanToast(i18next.t('createToast.convert'));
      return;
    }
    if (file) {
      this.file = file;
      this.countFiles++;
      let path = file.path;
      if (!path.endsWith("/")) {
        path += "/";
      }
      const f = (await this.downloadFileSingle(path + file.name)); // this is the FileBuffer, from it we can access the content of the file

      const filename = file.name;
      // every line of the file is a cell formatted as a csv
      const buffer = f.getBuffer();

      const data = new FormData()
      data.append('file', new Blob(buffer), file.name)

      //let response = await fetch("https://localhost:44385/API/V1/Public/ConvertFile", {
      const response = await fetch("https://btstracker.com/API/V1/Public/ConvertFile", {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        body: data
      });
      const respTxt = await response.text();
      //console.warn("respTxt", respTxt)
      if (respTxt.indexOf("Date;") == -1) {
        this.createalert("File not suported or license not valid.");
        console.warn("file not supported ?")
      }
      else {
        this.createsuccess();
        downloadFileC(respTxt, filename + ".csv", "text/csv")
      }
    }
  }

  public async downloadFile(fileConvert?: FolderContainer) {
    console.log(fileConvert);
    let file: FolderContainer | undefined;
    if (fileConvert != undefined) {
      file = fileConvert;
    } else if (fileConvert == undefined && this.file != undefined) {
      file = this.file;
    }
    if (file == undefined) return;
    console.log(file);
    if (this.isScanning == true) {
      this.stopScanToast(i18next.t('createToast.download'));
      return;
    }
    this.countFiles++;
    if (file) {
      this.file = file;
      let path = file.path;
      if (!path.endsWith("/")) {
        path += "/";
      }
      // remove the file extension
      (await this.downloadFileSingle(path + file.name)).saveToFile(file.name);
      this.createsuccess();
    }
  }

  public async downloadFileSingle(fileName: string): Promise<FileBuffer> {
    if (!$BTSTracker.value.connected || !$BTSTracker.value.connectedDeviceId) {
      createToast(
        {
          title: i18next.t("createToast.notConnected"),
        }, {
        type: 'danger',
        showIcon: true,
        hideProgressBar: true,
      }
      ); throw "Not connected";
    }
    if ($BTSTracker.value.fileBuffer || $BTSTracker.value.fileBufferPromiseResolver) {
      createToast(
        {
          title: i18next.t("createToast.downloadingFile"),
        }, {
        type: 'danger',
        showIcon: true,
        hideProgressBar: true,
      }
      );
      throw "A file is already begin downloaded";
    }

    const cmdRsp: Record<string, any> = await this.sendCommand("download_file", { "file_name": fileName, "folder": this.folder }); // this return the file data, how many parts if exist and so on
    //console.log(cmdRsp);
    //console.log(fileName);
    if (cmdRsp.ok) {
      const msg = "" + cmdRsp.msg as string;
      const parts = parseInt(msg);
      //console.log("File parts " + parts);
      const fBuffer = new FileBuffer(fileName, parts);
      $BTSTracker.value.fileBuffer = fBuffer;
      let rsv: ((a: FileBuffer) => void) = () => { return; };
      const prm = new Promise<FileBuffer>((resolve) => rsv = resolve);
      $BTSTracker.value.fileBufferPromiseResolver = rsv;
      await BleClient.write($BTSTracker.value.connectedDeviceId.deviceId, FILEMANAGER_SERVICE_CHARA, FILEMANAGER_COMMAND_FB_CHARA, new DataView(new Int32Array([0]).buffer, 0, 4));
      //console.log("Download file method finished his execution");
      if (parts == 0) {
        if (rsv) {
          rsv($BTSTracker.value.fileBuffer);
          $BTSTracker.value.fileBuffer = undefined;
          $BTSTracker.value.fileBufferPromiseResolver = undefined;
          //console.log("!! FILE DOWNLOADED !!");
        }
      }
      return prm;
    } else {
      throw "Error while downloading a file: " + cmdRsp.msg as string;
    }
  }


  stopScanToast(operation: string) {
    createToast(
      {
        title: i18next.t('createToast.stopError1') + operation + i18next.t('createToast.stopError2'),
        description: i18next.t('createToast.description1') + operation + i18next.t('createToast.stopError2')
      },
      {
        type: 'danger',
        showIcon: true,
        hideProgressBar: true,
      });
  }

  createalert(v: string) {
    createToast(
      {
        title: i18next.t('createToast.error'),
        description: v,
      }, {
      type: 'danger',
      showIcon: true,
      hideProgressBar: true,
    }
    );
  }

  createsuccess() {
    createToast(
      {
        title: i18next.t('createToast.complete'),
      }, {
      type: 'success',
      showIcon: true,
      hideProgressBar: true,
    }
    );
  }



  public async sendFileDownloadRequest(): Promise<FileBuffer> {
    if (!$BTSTracker.value.connected || !$BTSTracker.value.connectedDeviceId) {
      createToast(
        {
          title: i18next.t("createToast.notConnected"),
        }, {
        type: 'danger',
        showIcon: true,
        hideProgressBar: true,
      }
      ); throw "Not connected";
    }

    const cmdRsp: Record<string, any> = await this.sendCommand("test_file", {}); // this return the file data, how many parts if exist and so on
    if (cmdRsp.ok) {
      const msg = "" + cmdRsp.msg as string;
      const parts = parseInt(msg);
      const fBuffer = new FileBuffer("/BTSdetails.txt", parts);
      $BTSTracker.value.fileBuffer = fBuffer;
      let rsv: ((a: FileBuffer) => void) = () => { return; };
      const prm = new Promise<FileBuffer>((resolve) => rsv = resolve);
      $BTSTracker.value.fileBufferPromiseResolver = rsv;
      await BleClient.write($BTSTracker.value.connectedDeviceId.deviceId, FILEMANAGER_SERVICE_CHARA, FILEMANAGER_COMMAND_FB_CHARA, new DataView(new Int32Array([0]).buffer, 0, 4));
      if (parts == 0) {
        if (rsv) {
          rsv($BTSTracker.value.fileBuffer);
          $BTSTracker.value.fileBuffer = undefined;
          $BTSTracker.value.fileBufferPromiseResolver = undefined;
          //console.log("!! FILE DOWNLOADED !!");
        }
      }
      return prm;
    } else {
      createToast(
        {
          title: i18next.t("createToast.Error"),
        }, {
        type: 'danger',
        showIcon: true,
        hideProgressBar: true,
      }
      );
      throw "Error while downloading a file: " + cmdRsp.msg as string;
    }
  }

  public async getFolders(): Promise<FoldersBuffer> {
    //console.log("get files");
    if (!$BTSTracker.value.connected || !$BTSTracker.value.connectedDeviceId) throw "Not connected";
    if ($BTSTracker.value.fileBuffer || $BTSTracker.value.fileBufferPromiseResolver) throw "A file is already begin downloaded";
    if ($BTSTracker.value.folderBuffer || $BTSTracker.value.folderBufferPromiseResolver) throw "A folder is already begin downloaded";

    const cmdResp: Record<string, any> = await this.sendCommand("get_files", { "path": $BTSTracker.value.folder }); // this return the file data, how many parts if exist and so on
    if (!cmdResp.ok) throw "Error while Fetching files: " + cmdResp.msg as string;
    //console.log(cmdResp);
    let msg = "";
    if (cmdResp.msg == "deleteAllFiles") {
      msg = "0";
    } else {
      msg = "" + cmdResp.msg as string;
    }
    const parts = parseInt(msg);
    //console.log("Folder parts " + parts);
    const fBuffer = new FoldersBuffer(parts);
    $BTSTracker.value.folderBuffer = fBuffer;
    let rsv;
    const prm = new Promise<FoldersBuffer>((resolve) => rsv = resolve);
    $BTSTracker.value.folderBufferPromiseResolver = rsv;
    await BleClient.write($BTSTracker.value.connectedDeviceId.deviceId, FILEMANAGER_SERVICE_CHARA, FILEMANAGER_COMMAND_FB_CHARA, new DataView(new Int32Array([0]).buffer, 0, 4));
    $BTSTracker.value.availableAt = new Date().getTime();
    return prm;
  }

  async handleChecksumFeedback(result: DataView) {
    //console.log("handleChecksumFeedback");
    if (!$BTSTracker.value.connected || !$BTSTracker.value.connectedDeviceId) throw "Not connected";
    if (!$BTSTracker.value.fileBuffer || !$BTSTracker.value.fileBufferPromiseResolver) throw "No file is being downloaded";
    $BTSTracker.value.fileBuffer.currentChecksum = BTSTracker.stringDecoder.decode(result);
    //console.log("RECEIVED CHECKSUM --> " + $BTSTracker.value.fileBuffer.currentChecksum);
    await BleClient.write($BTSTracker.value.connectedDeviceId.deviceId, FILEMANAGER_SERVICE_CHARA, FILEMANAGER_COMMAND_FB_CHARA, new DataView(new Int32Array([0]).buffer, 0, 4));
  }

  async handleFileManagerReceiver(result: DataView) {
    console.log("handleFileManagerReceiver");
    if (!$BTSTracker.value.connected || !$BTSTracker.value.connectedDeviceId) throw "Not connected";
    if ($BTSTracker.value.fileBuffer && $BTSTracker.value.fileBufferPromiseResolver) {
      $BTSTracker.value.fileBuffer.addPart(result);
      $BTSTracker.value.fileBuffer.currentChecksum = "";
      if ($BTSTracker.value.fileBuffer.isComplete()) {
        if ($BTSTracker.value.fileBufferPromiseResolver) {
          $BTSTracker.value.fileBufferPromiseResolver($BTSTracker.value.fileBuffer);
          $BTSTracker.value.fileBuffer = undefined;
          $BTSTracker.value.fileBufferPromiseResolver = undefined;
          //console.log("!! FILE DOWNLOADED !!");
        }
      }
    }

    if ($BTSTracker.value.folderBuffer) {
      const data = BTSTracker.stringDecoder.decode(result);
      $BTSTracker.value.folderBuffer.addPart(data);

      await BleClient.write($BTSTracker.value.connectedDeviceId.deviceId, FILEMANAGER_SERVICE_CHARA, FILEMANAGER_COMMAND_FB_CHARA, new DataView(new Int32Array([0]).buffer, 0, 4));

      if ($BTSTracker.value.folderBuffer != undefined) {
        if ($BTSTracker.value.folderBuffer.isComplete()) {
          if ($BTSTracker.value.folderBufferPromiseResolver) {
            $BTSTracker.value.folderBufferPromiseResolver($BTSTracker.value.folderBuffer);
            $BTSTracker.value.folderBuffer = undefined;
            $BTSTracker.value.folderBufferPromiseResolver = undefined;
            //console.log("!! FOLDER DOWNLOADED !!");
          }
        }
      }
    }
    $BTSTracker.value.availableAt = new Date().getTime();
  }

  getVersionDate(versione: string): Array<number> {
    const values = versione.split(".");
    const year = Number(values[4].charAt(0) + values[4].charAt(1));
    const day = Number(values[4].charAt(2) + values[4].charAt(3) + values[4].charAt(4));

    return new Array<number>(year, day);
  }



}

const _downloadFile = (data: string, fileName: string, type: string) => {

  // Create an invisible A element
  const a = document.createElement("a");
  a.style.display = "none";
  document.body.appendChild(a);

  // Set the HREF to a Blob representation of the data to be downloaded
  a.href = data;

  // Use download attribute to set set desired file name
  a.setAttribute("download", fileName);

  // Trigger the download by simulating click
  a.click();

  // Cleanup
  window.URL.revokeObjectURL(a.href);
  document.body.removeChild(a);
}



export const $BTSTracker = ref(new BTSTracker());
